/* Built by harness/build-scene-pages.cjs from src/scene-pages/pages/bounty.js. Edit the source, then rebuild. */
/* bounty, round two: "a price on your character's head". A player toy, with a DM switch in its opening box.
   Everything plays inside the frame (ctx.frame, src/scene-pages/core.js). The reader names their character, picks the
   charge and rolls the reward; Sheriff Hobb of Marrow's End writes it all onto a poster, the reader nails it up by
   tapping it, and the hunters the reward deserves walk up to read it. The poster is HTML laid inside the frame's art
   under the canvas, in the rectangle the scene publishes (val.geo), and the scene leaves that rectangle see-through,
   so Hobb's hammer, the nails, the lantern's light and the hunters stay in front of the paper.
   Clickable in the picture: the lantern, Hobb, his hammer, the poster (or the bare patch), the missing notice, the
   tear-off tabs, the sheriff's notice, Hobb's slate, the cat, and every hunter. Under the frame sit the DM's hunters
   table and notes.
   Round four, shared: every player's posters ('bounty.posted') and the gold on them ('bounty.gold') add up. The posters
   stay up, so the paper round the reader's thickens with everyone's earlier ones (val stack), and after each nailing
   Hobb walks to his slate and chalks the gold on every head in Marrow's End (an HTML number laid over the slate). The
   small twist is the going rate: Hobb says how the reader's reward stands against everyone's average.
   On the store (sections/ff-scene-page.liquid, templates/page.scene-bounty.json) the totals count in this browser only
   until the shared results are installed (FFD.tally.shared false). Every number here is Marrow's End's own (the board's
   posters and Hobb's slate start from a few that were up before anyone played), so no line speaks for other players.
   Gillic Grimson and Whiskers are customers' Hall heroes: on the store they come only once their pixel ids are in
   window.FFD_HEROES_OK (heroOk below), and until then the DM's ranger and dwarf hunt in their place.
   The likeness (Jan, 2026-10-07: "the bounty page's WANTED board takes an uploaded character image"): at the end of a
   round "Add a likeness" picks a picture from the device, a small sheet fits it to the poster's frame (drag, pinch, the
   wheel, a slider or the 44 px buttons), and it is inked in the poster's own sepia into the frame, on the board and on
   the saved poster. Only the inked picture (a small JPEG, about 20 KB) is kept, in this browser
   (localStorage 'ffd-bounty-likeness', with the character's name, so the same character's next poster has it too);
   the original never leaves the device and nothing is uploaded. "Remove it" clears both.
   Scene: 'demo-bounty-board' (src/scene-pages/scenes/bounty.js). */
(() => {
  'use strict';
  const KEY = 'demo-bounty-board';
  const RM = () => FFD.RM();

  /* ---------- easter eggs (round six, 2026-10-05) ----------
     Jan: "all those pages should have things that can be interacted with that are just easter eggs that dont
     neccessaary serve a function other than to delight and enteratin and be fun". Here: the cat and Hobb's tin of nails
     on the ledge, and a snail on the wet board (scenes/bounty.js draws them and publishes their buttons, egg-tin and
     egg-snail). A tap plays a little scene with its sound, and the next tap the next one. They say nothing in the box
     and change nothing in the story. They work whenever the picture is free to touch, the first screen and every
     choice included, and are off only while something covers it or moves in it: a sheet, a tap to continue, the dice,
     a change of scene or the page's own animations (o.hold). The scene drops an egg's button whenever another button
     would overlap it (val.eggOn, val.eggK: how many CSS px a grid pixel is). */
  function eggKit(F, ctx, o) {
    const W = { scene: 0 }, n = {}, blocks = {};
    const ok = () => {
      if (!ctx.alive()) return false;
      const c = F.el.classList;
      if (c.contains('is-busy') || c.contains('has-sheet') || c.contains('is-gate')) return false;
      if (W.scene || F.el.querySelector('.ffs-tray.is-in')) return false;
      return !(o.hold && o.hold());
    };
    /* anything of the page's that may lie over an egg's button: a story pill, the corner tools and name, the page's own
       overlays (o.cover). A covered egg stays off until that very thing has gone */
    const COVER = '.ffs-pill.is-in:not(.is-lost):not(.is-out), .ffs-top .ffs-tool, .ffs-home, .ffs-name:not(.is-hid)' + (o.cover ? ', ' + o.cover : '');
    const over = (p, q) => Math.min(p.right, q.right) - Math.max(p.left, q.left) > 0.5 && Math.min(p.bottom, q.bottom) - Math.max(p.top, q.top) > 0.5;
    const tick = () => {
      if (!ctx.alive()) return;
      const on = ok(), k = Math.round((F.toCss(10, 0).x - F.toCss(0, 0).x) * 10) / 100;
      if (F.get('eggOn') !== on) F.set('eggOn', on);
      if (k > 0 && F.get('eggK') !== k) F.set('eggK', k);
      const els = [...F.el.querySelectorAll(COVER)].filter((e) => e.offsetWidth), B = {};
      Object.keys(o.eggs).forEach((id) => {
        if (blocks[id] && els.indexOf(blocks[id]) >= 0) { B[id] = 1; return; }
        blocks[id] = null;
        const b = F.el.querySelector('.ffs-hot[data-hot="' + id + '"]'); if (!b) return;
        const r = b.getBoundingClientRect(), hit = els.find((e) => over(r, e.getBoundingClientRect()));
        if (hit) { blocks[id] = hit; B[id] = 1; }
      });
      const was = F.get('eggBlock') || {};
      if (Object.keys(B).sort().join() !== Object.keys(was).sort().join()) F.set('eggBlock', B);
    };
    ['scene'].forEach((k) => {
      const f0 = F[k]; if (typeof f0 !== 'function') return;
      F[k] = function () {
        W[k]++; tick();
        let p;
        try { p = f0.apply(F, arguments); } catch (e) { W[k]--; throw e; }
        Promise.resolve(p).then(() => { W[k]--; tick(); }, () => { W[k]--; tick(); });
        return p;
      };
    });
    const iv = setInterval(tick, 160);
    ctx.onKill(() => clearInterval(iv));
    F.ready.then(tick).catch(() => {});
    const hots = {};
    Object.keys(o.eggs).forEach((id) => {
      hots[id] = { label: o.eggs[id].label, sound: false, tap: () => { if (!ok()) return; n[id] = (n[id] || 0) + 1; F.act('egg', { id, n: n[id] }); } };
    });
    return { hots, ok };
  }
  /* the eggs' sounds, in step with the picture (the scene emits 'egg' { beat }): quiet Web Audio that follows the
     sound button */
  let eggNoise = null;
  function eggSnd(beat) {
    const S = window.FFSound; if (!S || S.muted || !beat) return;
    const ac = S.wake(); if (!ac) return;
    try {
      if (!eggNoise) { eggNoise = ac.createBuffer(1, ac.sampleRate, ac.sampleRate); const d = eggNoise.getChannelData(0); for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1; }
      const out = ac.createGain(); out.gain.value = 0.5; out.connect(ac.destination);
      const t0 = ac.currentTime + 0.005, R = (a, b) => a + Math.random() * (b - a);
      const nz = (t, type, f, q, g, d, f2) => {
        const s = ac.createBufferSource(); s.buffer = eggNoise;
        const fl = ac.createBiquadFilter(); fl.type = type; fl.frequency.setValueAtTime(f, t); fl.Q.value = q; if (f2) fl.frequency.exponentialRampToValueAtTime(f2, t + d);
        const gn = ac.createGain(); gn.gain.setValueAtTime(0.0001, t); gn.gain.linearRampToValueAtTime(g, t + 0.004); gn.gain.exponentialRampToValueAtTime(0.0001, t + d);
        s.connect(fl).connect(gn).connect(out); s.start(t, Math.random() * 0.5); s.stop(t + d + 0.05);
      };
      const tn = (t, f, f2, g, d, type) => {
        const s = ac.createOscillator(); s.type = type || 'sine'; s.frequency.setValueAtTime(f, t); if (f2) s.frequency.exponentialRampToValueAtTime(f2, t + d);
        const gn = ac.createGain(); gn.gain.setValueAtTime(0.0001, t); gn.gain.linearRampToValueAtTime(g, t + 0.006); gn.gain.exponentialRampToValueAtTime(0.0001, t + d);
        s.connect(gn).connect(out); s.start(t); s.stop(t + d + 0.05);
      };
      /* the tin: a tap of paw on tin, its nails rattling as it teeters, the shove off, the clatter down below */
      if (beat === 'tink') { tn(t0, 2150, 0, 0.05, 0.14, 'triangle'); tn(t0, 3230, 0, 0.022, 0.09); nz(t0, 'highpass', 4200, 1, 0.03, 0.02); }
      else if (beat === 'wobble') { for (let i = 0; i < 7; i++) { const t = t0 + i * 0.075 + R(0, 0.02); tn(t, R(2300, 3300), 0, 0.022 * (1 - i / 9), 0.05, 'triangle'); nz(t, 'highpass', 5000, 1, 0.015, 0.015); } }
      else if (beat === 'shove') { nz(t0, 'bandpass', 1600, 1.2, 0.06, 0.16, 500); tn(t0, 2000, 0, 0.035, 0.1, 'triangle'); }
      else if (beat === 'clatter') { nz(t0, 'lowpass', 320, 1.2, 0.16, 0.12); for (let i = 0; i < 9; i++) { const t = t0 + i * R(0.025, 0.05) + (i > 5 ? 0.1 : 0); tn(t, R(1900, 3600), 0, 0.03 * (1 - i / 11), 0.07, 'triangle'); } }
      else if (beat === 'scrabble') { for (let i = 0; i < 7; i++) nz(t0 + i * R(0.025, 0.04), 'highpass', R(2400, 5200), 0.8, R(0.03, 0.06), 0.025); }
      else if (beat === 'mrrp') { tn(t0, 520, 760, 0.05, 0.12); tn(t0 + 0.1, 760, 600, 0.04, 0.16); }
      else if (beat === 'swish') nz(t0, 'bandpass', 900, 0.8, 0.05, 0.14, 2400);
      /* the snail: in with a wet plop, a slither down, the zoom, a boing of its stalks, a raindrop on its shell */
      else if (beat === 'plop') { tn(t0, 620, 240, 0.06, 0.09); nz(t0, 'lowpass', 900, 1, 0.03, 0.05); }
      else if (beat === 'slip') { tn(t0, 880, 480, 0.03, 0.26, 'triangle'); nz(t0, 'bandpass', 1200, 2, 0.02, 0.22, 600); }
      else if (beat === 'zoom') { nz(t0, 'bandpass', 420, 0.7, 0.1, 0.28, 3200); tn(t0, 300, 1300, 0.03, 0.26, 'triangle'); }
      else if (beat === 'boing') { tn(t0, 250, 520, 0.05, 0.13, 'triangle'); tn(t0 + 0.12, 520, 380, 0.035, 0.16, 'triangle'); }
      else if (beat === 'plink') { tn(t0, 1900, 900, 0.05, 0.09); tn(t0, 2700, 0, 0.018, 0.06); }
    } catch (e) { /* never break the page for a sound */ }
  }

  /* ---------- the charges: the choice, the poster's wording, Hobb's starting price, his note ---------- */
  const CHARGES = [
    { label: 'Opened the vault nobody was supposed to open', poster: 'opening the vault nobody was supposed to open', base: 80,
      note: 'Nobody will say what was in the vault. Hobb was told to stop asking.' },
    { label: 'Freed every prisoner, including the guilty one', poster: 'freeing every prisoner, including the guilty one', base: 70,
      note: 'The guilty one sent a thank you note. Hobb has filed it as evidence.' },
    { label: 'Insulted a duke in rhyme, in his own hall', poster: 'insulting a duke in rhyme, in his own hall', base: 90,
      note: 'The duke asked Hobb not to print the rhyme. Half the town sings it.' },
    { label: 'Burned down the wrong barn', poster: 'burning down the wrong barn', base: 40,
      note: 'The right barn is still standing, and its owner hasn’t slept since.' },
    { label: 'Stole back what was stolen first', poster: 'stealing back what was stolen first', base: 30,
      note: 'The first thief has complained. Hobb takes it far too seriously.' },
    { label: 'Talked a guard captain into early retirement', poster: 'talking a guard captain into early retirement', base: 60,
      note: 'The captain has never been happier. Hobb is short one captain.' }
  ];
  const OWN = { label: 'Something else, in my own words', base: 50, note: 'Hobb writes it down word for word and underlines it twice.' };

  /* ---------- customers' Hall heroes ----------
     Jan's rule is that a customer's Hall hero shows on a public page only once its owner has said yes. On the store (FFD.live)
     a hero plays only when its pixel id is in window.FFD_HEROES_OK, the list the section prints from the template's
     heroes setting (empty until an owner says yes); 'ember' is Jan's own and always allowed. The review demo keeps
     every hero. Read each time it matters, so the list can arrive after this script. */
  const HEROES = ['gillic', 'whiskers'];
  const heroOk = (id) => {
    if (id === 'ember' || !FFD.live) return true;
    let L = window.FFD_HEROES_OK;
    if (typeof L === 'string') L = L.split(',');
    return Array.isArray(L) && L.some((x) => String(x).trim() === id);
  };
  const heroesOk = () => HEROES.filter(heroOk);
  /* their names for the box on the store, where there is no demo hero list */
  const HERO_NAMES = { gillic: 'Gillic Grimson', whiskers: 'Laith “Whiskers” Reed' };

  /* ---------- who comes to read it, by the reward: the box's lines, then each hunter's name and what they say when
     tapped (in the scene's own order, so h0 is the first figure of that cast). The two best casts are built when the
     hunters come (castOf), each Hall hero or the DM's hunter who stands in for them ---------- */
  const HUNT = {
    /* two of Jan's featured Hall heroes, in their own words (their Hall catchphrase, habit and story) */
    gillic: { who: 'Gillic Grimson', barks: ['“Which one of you is worth the most? Never mind. I can read.”', '“Armor slows you down. They have to catch me first, and nobody has.”', '“Once I’m tracking, I don’t stop. Last time it was a bread roll.”'],
      crowd: ['“Spell my name right on the receipt, Hobb.”', '“Two of you owe me lunch, and I haven’t forgotten.”'] },
    whiskers: { who: 'Whiskers', barks: ['“Who bakes here? I ask that first in every town, before the job.”', '“The axe was my mentor’s. I keep it wrapped so it stays nice.”', '“Have a cookie. You look like you needed one about an hour ago.”'] },
    /* the DM's own hunters (the table under the frame, rows 3 and 4) */
    ranger: { who: 'The ranger', barks: ['“Mud from the Hollow Stump road. I’d know it anywhere.”', '“I don’t blink. It makes the guilty nervous.”', '“Half up front. The rest when I bring back the boots.”'],
      crowd: ['“A doubled reward brings out the whole town. Stay behind me.”', '“I’ll have them by morning. Mud never lies.”'] },
    dwarf: { who: 'The dwarf', barks: ['“Nine names in this ledger, all crossed out. Room for one more.”', '“The crossbow is for show. The ledger does the work.”', '“Hobb pays on the nail. That’s why I hunt here.”'] }
  };
  const CAST_FN = {
    ranger: () => {
      const a = heroOk('gillic') ? 'gillic' : 'ranger', b = heroOk('whiskers') ? 'whiskers' : 'dwarf';
      return {
        arrive: a === 'gillic' ? 'Gillic Grimson is reading it before the ink is dry.' : 'A ranger who never blinks is reading it before the ink is dry.',
        lines: (a === 'gillic'
          ? [{ hero: 'gillic', text: 'Gillic checks this board before the menu.' }, { talk: 0, cheer: true, bark: '“Put me down for {Name}. Spell my name right this time.”' }]
          : [{ text: 'She tracks people by the mud on their boots.' }, { talk: 0, bark: '“Put me down for {Name}. I’ll start with the boots.”' }])
          .concat(b === 'whiskers'
            ? [{ hero: 'whiskers', talk: 1, bark: '“Dark gods, dark days. Good reward though.”', text: 'Whiskers came for the best cookie in town and found a job too.' }]
            : [{ talk: 1, bark: '“Nine caught. {Name} makes ten.”', text: 'The dwarf writes the name in his ledger before he reads the rest.' }]),
        who: [HUNT[a].who, HUNT[b].who],
        barks: [HUNT[a].barks, HUNT[b].barks]
      };
    },
    crowd: () => {
      const a = heroOk('gillic') ? 'gillic' : 'ranger';
      return {
        arrive: 'Half the street comes out in the rain to read it.',
        lines: (a === 'gillic'
          ? [{ hero: 'gillic', text: 'Gillic Grimson pushes to the front of the crowd.' }, { talk: 0, cheer: true, bark: '“Doubled. Which one of you is worth the most? Oh. It’s {Name}.”' }]
          : [{ text: 'The ranger who never blinks pushes to the front.' }, { talk: 0, bark: '“Doubled, and I’m taking it. Oh, it’s {Name}.”' }])
          .concat([{ talk: 1, bark: '“Hot pies. Nobody hunts well on an empty stomach.”' }]),
        who: [HUNT[a].who, 'The pie seller', 'A child', 'Hobb’s mother', 'The man in the top hat'],
        barks: [HUNT[a].crowd, ['“Mutton or apple. The apple’s gone.”', '“Hot pies. Nobody hunts well on an empty stomach.”'],
          ['“Is it a real one? Is it?”', '“I’m going to be a hunter. Mum says after supper.”'], ['“My son wrote that. Lovely hand, hasn’t he.”', '“He drew the likenesses himself once. We don’t talk about the scarecrow.”'],
          ['“I only copy them. Who for is my own business.”']]
      };
    }
  };
  const castOf = (name) => (CAST_FN[name] ? CAST_FN[name]() : CASTS[name]);
  const CASTS = {
    farm: { arrive: 'Two farmhands with one pitchfork stop to read it.',
      lines: [{ text: 'They once brought in a scarecrow.' },
        { talk: 0, bark: '“We’ll go in the morning. When it’s light.”' }],
      who: ['The farmhand', 'The other farmhand'],
      barks: [['“Last time we brought in a scarecrow. It had a very guilty face.”', '“One fork between two of us is plenty.”', '“We’ll go in the morning. When it’s light.”'],
        ['“My uncle saw a wanted man once. He still talks about it at supper.”', '“I’ve got the lantern, so I’m in charge.”']] },
    swords: { arrive: 'Two sellswords off the Hollow Stump road stop to read it.',
      lines: [{ talk: 1, bark: '“Half now, half when we find them.”', text: 'They agree on a split before a plan.' }],
      who: ['The sellsword', 'The shieldmaiden'],
      barks: [['“That’s a lot of gold for a name I’ve never heard.”', '“Read it again. Slower.”'],
        ['“I read faster than he does. He hates that.”', '“Everyone ends up on the Hollow Stump road sooner or later.”', '“Half now, half when we find them.”']] },
    /* ranger (280 gold and up) and crowd (a natural 20) are built by CAST_FN above */
    muddle: { arrive: 'A farmhand, a sellsword and a dwarf are already arguing about the number.',
      lines: [{ talk: 1, bark: '“Nine hundred. Count the noughts.”', text: 'The farmhand says 9, and that he’s going either way.' }],
      who: ['The farmhand', 'The dwarf', 'The sellsword'],
      barks: [['“Nine gold. I’m going either way.”'], ['“I know Hobb’s noughts. That’s two of them.”', '“Nine hundred. Count the noughts.”'], ['“Ninety. It’s obviously ninety.”']] }
  };

  /* ---------- what the things in the picture say when touched (each list cycles) ---------- */
  const HOBB = ['“Name, charge and reward. Everything else is gossip.”', '“I stopped drawing the likenesses. Don’t ask about the scarecrow.”',
    '“Rain can’t reach the ink under this roof. I built it myself.”', '“Keep poking me and your name goes up next.”'];
  const LANTERN = [{ text: 'The lantern swings on its chain, and the moths scatter.' }, { text: 'The flame ducks and comes back taller.' },
    { text: '“Leave the lantern be. It’s the only one in town that works.”', who: 'Sheriff Hobb' }];
  const RAP = ['Hobb raps the board with his hammer. The roof shakes its rain loose.', '“Good oak,” says Hobb, and raps it again.'];
  const OLD = ['Twelve vanished on the Hollow Stump road. Nobody has taken that job.',
    'Twelve figures in red ink, one for each traveller who never arrived.', 'The reward on it has been raised twice, and it’s still up.'];
  const TABS = ['Lost goat, answers to Duchess. A tab comes away in your fingers.', 'Another tab gone. Duchess is popular.', 'Somebody in this town really wants that goat found.'];
  const TABS_DONE = 'No tabs left. Whoever owns Duchess is about to get a lot of visitors.';
  const NOTICE = ['No notices after the second bell, by order. Hobb hangs his after it.', 'The seal is Hobb’s. He presses it hard enough to dent the board.'];
  const CAT = ['The cat hisses and goes up on the roof. It’ll be back.', 'That cat has read every poster here and never told Hobb a thing.'];
  const PATCH = ['Old posters, one over the next. Nobody here takes a poster down.', 'New ones go on top. The rain takes the old ones in its own time.'];
  const SLATE = ['Every reward posted in Marrow’s End, chalked up by Hobb.', 'Hobb rubs it out and chalks it bigger every time.', 'Somebody chalked a small goat in the corner. Hobb left it.'];
  /* Hobb's chalk snail for the slate: a shell, its foot and two stalks, as chalk pixels (10 by 5) */
  const SNAIL_PX = ['...###....', '..#...#..#', '..#.#.#..#', '..#..##.##', '#########.'];
  function chalkSnail() {
    const NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 10 5'); svg.setAttribute('class', 'bnt-chalk'); svg.setAttribute('aria-hidden', 'true');
    SNAIL_PX.forEach((row, y) => row.split('').forEach((ch, x) => {
      if (ch !== '#') return;
      const r = document.createElementNS(NS, 'rect');
      r.setAttribute('x', x); r.setAttribute('y', y); r.setAttribute('width', 1); r.setAttribute('height', 1); r.setAttribute('fill', (x + y) % 3 ? '#ebe5d6' : '#cfc8b8');
      svg.append(r);
    }));
    return svg;
  }
  /* the seventh day the page was opened: the snail has climbed the board all week, and Hobb chalks it on his slate */
  const SNAIL_LINE = '“That snail’s wanted for loitering.”';
  const POSTER = ['The loose corner lifts in the draught.', 'The ink is still wet on {Name}’s name.', 'Hobb nailed three corners and left the fourth for luck.'];

  /* ---------- the page's own look ---------- */
  /* round five (Jan: "a clean premium experience"): the core styles the box, chips, pills and bubbles; this page styles
     only what it owns (the poster, the slate, the reference), the slate and the reference in the core's language */
  const CSS = `
.ffd-page--bounty .ffs-art canvas.qo-scenes__cv { z-index: 1; }
.ffd-page--bounty .bnt-poster { position: absolute; left: 0; top: 0; width: 10px; height: 10px; z-index: 0; pointer-events: none; visibility: hidden; color: #1b1712; overflow: hidden; contain: layout paint; }
.ffd-page--bounty .bnt-poster.is-on { visibility: visible; }
.ffd-page--bounty .bnt-poster canvas { animation: none; }
.ffd-page--bounty .bnt-paper { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 1; image-rendering: pixelated; image-rendering: crisp-edges; }
.ffd-page--bounty .bnt-p { position: absolute; left: 6%; right: 6%; text-align: center; white-space: nowrap; line-height: 1; }
.ffd-page--bounty .bnt-p-wanted { top: 5.4%; font: 700 1.62em/1 var(--f-display); letter-spacing: .07em; color: #22120b; text-shadow: 0 .03em 0 rgba(255,246,220,.35); }
.ffd-page--bounty .bnt-p-name { top: 21.6%; font: italic 700 1.42em/1 var(--f-aside); color: #1c1830; }
.ffd-page--bounty .bnt-p-class { top: 32.6%; font: 600 .48em/1 var(--f-display); letter-spacing: .16em; color: #3a2a1e; text-transform: uppercase; }
.ffd-page--bounty .bnt-p-like { top: 39.8%; height: 17.4%; left: 32.5%; right: 32.5%; display: flex; flex-direction: column; align-items: center; justify-content: center; font: italic 600 .58em/1.08 var(--f-aside); color: #5e4e3e; }
.ffd-page--bounty .bnt-p-for { top: 60.6%; font: 600 .44em/1 var(--f-display); letter-spacing: .2em; color: #3a2a1e; }
.ffd-page--bounty .bnt-p-charge { top: 64.4%; left: 8%; right: 8%; height: 14.6%; display: flex; align-items: center; justify-content: center; white-space: normal; font: italic 600 .76em/1.06 var(--f-aside); color: #1c1830; }
.ffd-page--bounty .bnt-p-rlabel { top: 82.4%; font: 600 .44em/1 var(--f-display); letter-spacing: .2em; color: #3a2a1e; }
.ffd-page--bounty .bnt-p-reward { top: 85.4%; left: 24%; right: 6%; font: italic 700 1.42em/1 var(--f-aside); color: #1c1830; }
.ffd-page--bounty .bnt-p-reward .bnt-old { position: relative; margin-right: .3em; font-size: .7em; color: #4a3a30; }
.ffd-page--bounty .bnt-p-reward .bnt-old::after { content: ''; position: absolute; left: -.1em; right: -.1em; top: 52%; height: .09em; background: #8c1a22; transform: scaleX(0); transform-origin: left; transition: transform .26s ease-out; }
.ffd-page--bounty .bnt-p-reward .bnt-old.is-struck::after { transform: scaleX(1); }
.ffd-page--bounty .bnt-p-reward .bnt-gold { font-size: .6em; font-weight: 600; margin-left: .18em; }
.ffd-page--bounty .bnt-p-reward .bnt-amt { display: inline-block; border-bottom: .07em solid rgba(140,26,34,.85); padding: 0 .06em .02em; }
.ffd-page--bounty .bnt-p-foot { top: 95.6%; font: 600 .3em/1 var(--f-display); letter-spacing: .14em; color: #4a3a2e; }
.ffd-page--bounty .bnt-poster.is-small .bnt-p-foot { display: none; }
.ffd-page--bounty .bnt-poster.is-small .bnt-p-class { font-size: .56em; letter-spacing: .12em; }
.ffd-page--bounty .bnt-poster.is-small .bnt-p-for, .ffd-page--bounty .bnt-poster.is-small .bnt-p-rlabel { font-size: .52em; letter-spacing: .14em; }
.ffd-page--bounty .bnt-poster.is-small .bnt-p-like { font-size: .64em; }
.ffd-page--bounty .bnt-poster.is-small .bnt-p-charge { font-size: .86em; left: 6%; right: 6%; }
.ffd-page--bounty .bnt-ink { clip-path: inset(0 100% 0 0); }
.ffd-page--bounty .bnt-ink.is-in { clip-path: inset(0 0 0 0); transition: clip-path var(--bnt-ms, 520ms) linear; }
.ffd-page--bounty .bnt-wet { text-shadow: 0 0 .05em rgba(80,90,160,.55); transition: text-shadow 2.4s ease; }
.ffd-page--bounty .bnt-word { opacity: 0; display: inline-block; transform: translateY(.06em); }
.ffd-page--bounty .bnt-word.is-in { opacity: 1; transform: none; transition: opacity .16s linear, transform .2s ease-out; }
.ffd-page--bounty .bnt-blot { position: absolute; image-rendering: pixelated; pointer-events: none; opacity: 0; transform: scale(.4); transform-origin: 50% 40%; }
.ffd-page--bounty .bnt-blot.is-in { opacity: 1; transform: none; transition: opacity .12s linear, transform .3s cubic-bezier(.2,1.5,.4,1); }
.ffd-page--bounty .bnt-smudge { filter: blur(.035em); opacity: .78; transition: filter .5s ease, opacity .5s ease; }
.ffd-page--bounty .bnt-own { display: flex; flex-direction: column; gap: 10px; }
.ffd-page--bounty .bnt-own-go { display: flex; justify-content: center; margin-top: 2px; }
.ffd-page--bounty .bnt-dm table { width: 100%; border-collapse: collapse; margin: 6px 0 14px; font-size: 15.5px; line-height: 1.5; }
.ffd-page--bounty .bnt-dm td { padding: 8px 6px; border-top: 1px solid rgba(200,164,94,.14); vertical-align: top; color: var(--fg-2); }
.ffd-page--bounty .bnt-dm td:first-child { width: 2.2em; color: var(--gold); font: 600 14px var(--f-display); text-align: center; }
/* Hobb's slate, everyone's gold, chalked (HTML over the pixel slate, so it reads): the sum in Cinzel, one small line */
.ffd-page--bounty .bnt-slate { position: absolute; z-index: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: .18em; pointer-events: none; visibility: hidden;
  background: radial-gradient(ellipse at 30% 35%, #2c3346 0%, #1c2130 70%); color: #efe9da; text-align: center; font: 600 15px/1 var(--f-display); text-shadow: 0 0 3px rgba(240, 234, 220, .22); }
.ffd-page--bounty .bnt-slate.is-in { visibility: visible; }
/* the likeness, inked into the poster's frame (a canvas over the paper, its box set from the paper's own frame) */
.ffd-page--bounty .bnt-poster .bnt-pic { position: absolute; display: none; object-fit: cover; image-rendering: auto; }
.ffd-page--bounty .bnt-poster .bnt-pic.is-on { display: block; }
.ffd-page--bounty .bnt-p-like.is-pic { visibility: hidden; }
/* the fit sheet: the frame at the poster's shape, drag and zoom inside it */
.ffd-page--bounty .bnt-fit { display: grid; justify-items: center; gap: 12px; }
.ffd-page--bounty .bnt-fit-view { position: relative; display: block; width: min(100%, 340px); aspect-ratio: 360 / 230; padding: 0; border: 2px solid #2b1d18; border-radius: 2px;
  outline: 1px solid rgba(232, 224, 208, .32); outline-offset: 4px; background: #e8e0d0; overflow: hidden; touch-action: none; cursor: grab; -webkit-user-select: none; user-select: none; }
.ffd-page--bounty .bnt-fit-view:active { cursor: grabbing; }
.ffd-page--bounty .bnt-fit-view:focus-visible { outline: 2px solid var(--gold-hi); outline-offset: 4px; }
.ffd-page--bounty .bnt-fit-view canvas { display: block; width: 100%; height: 100%; pointer-events: none; }
.ffd-page--bounty .bnt-fit-wait { position: absolute; inset: 0; display: grid; place-items: center; margin: 0; font: italic 500 16px/1.3 var(--f-aside); color: #5e4e3e; }
.ffd-page--bounty .bnt-fit-zoom { display: flex; align-items: center; gap: 6px; width: min(100%, 340px); }
.ffd-page--bounty .bnt-fit-zoom input[type="range"] { flex: 1; min-width: 0; height: 44px; margin: 0; accent-color: var(--gold); background: transparent; cursor: pointer; }
.ffd-page--bounty .bnt-fit-zb { display: grid; place-items: center; flex: 0 0 44px; width: 44px; height: 44px; padding: 0; border-radius: 50%; border: 1px solid var(--hair); background: rgba(255, 236, 200, .03); color: var(--gold-hi); cursor: pointer; }
.ffd-page--bounty .bnt-fit-zb:hover { border-color: rgba(232, 198, 116, .6); background: rgba(200, 164, 94, .08); }
.ffd-page--bounty .bnt-fit-zb svg { width: 16px; height: 16px; }
.ffd-page--bounty .bnt-fit-tip { margin: 0; font: italic 500 16px/1.35 var(--f-aside); color: var(--fg-2); text-align: center; text-wrap: balance; }
.ffd-page--bounty .bnt-fit-note { margin: -4px 0 0; font: 13px/1.4 var(--f-body); color: var(--fg-3); text-align: center; }
.ffd-page--bounty .bnt-fit-go { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; width: 100%; }
.ffd-page--bounty .bnt-fit-go .ffs-chip { flex: 0 1 auto; padding-inline: 18px; }
.ffd-page--bounty .bnt-slate b { font: inherit; letter-spacing: .03em; font-variant-numeric: tabular-nums; }
.ffd-page--bounty .bnt-slate small { font: italic 500 .62em/1.1 var(--f-aside); letter-spacing: .01em; color: #cfc8b8; white-space: nowrap; }
/* the seventh day (an egg): Hobb's chalk snail beside the sum, a drawing in chalk pixels */
.ffd-page--bounty .bnt-slate-row { display: inline-flex; align-items: center; gap: .25em; white-space: nowrap; }
.ffd-page--bounty .bnt-chalk { width: 1em; height: .5em; opacity: .88; shape-rendering: crispEdges; flex: 0 0 auto; }
@media (prefers-reduced-motion: reduce) {
  .ffd-page--bounty .bnt-ink, .ffd-page--bounty .bnt-ink.is-in { clip-path: none; transition: none; }
  .ffd-page--bounty .bnt-word { opacity: 1; transform: none; }
  .ffd-page--bounty .bnt-blot { transition: none; transform: none; }
  /* the core shows every canvas in the art at once under reduced motion; the blot still waits for its natural 1 */
  .ffd-page--bounty .ffs-art .bnt-poster .bnt-blot { opacity: 0; }
  .ffd-page--bounty .ffs-art .bnt-poster .bnt-blot.is-in { opacity: 1; }
}`;
  function injectCSS() {
    if (document.getElementById('ffd-css-bounty')) return;
    const st = document.createElement('style'); st.id = 'ffd-css-bounty'; st.textContent = CSS; document.head.append(st);
  }

  /* ---------- the poster's paper, painted at the scene's own pixel size in the scene's palette ---------- */
  const HEX = { ol: '#1a1210', k1: '#2b1d18', lt1: '#40291e', lt2: '#5c3b27', hb: '#5b534d', mu: '#8b8178', pa2: '#b8ad98', pa: '#e8e0d0', hw: '#fff6dc',
    b1: '#4d0f14', b2: '#8c1a22', b3: '#ef4444', sk6: '#ecc9a0' };
  const RGB = {}; Object.keys(HEX).forEach((k) => { const v = HEX[k]; RGB[k] = [parseInt(v.slice(1, 3), 16), parseInt(v.slice(3, 5), 16), parseInt(v.slice(5, 7), 16)]; });
  const BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  const bay = (x, y) => (BAYER[((y & 3) << 2) | (x & 3)] + 0.5) / 16;
  function hash(x, y, s) {
    let v = (Math.imul(x | 0, 374761393) + Math.imul(y | 0, 668265263) + Math.imul((s | 0) + 1, 1442695041)) | 0;
    v = Math.imul(v ^ (v >>> 13), 1274126177);
    return ((v ^ (v >>> 16)) >>> 0) / 4294967296;
  }
  function vnoise(x, y, s) {
    const xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi, u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    const a = hash(xi, yi, s) + (hash(xi + 1, yi, s) - hash(xi, yi, s)) * u, b = hash(xi, yi + 1, s) + (hash(xi + 1, yi + 1, s) - hash(xi, yi + 1, s)) * u;
    return a + (b - a) * v;
  }
  /* the poster's layout, as shares of its size (the HTML text uses the same numbers in the CSS above) */
  const LAY = { rule1: 0.188, rule1b: 0.204, frame: [0.31, 0.375, 0.69, 0.585], rule2: 0.802, seal: [0.17, 0.893] };
  function paintPaper(cv, w, h) {
    cv.width = w; cv.height = h;
    const g = cv.getContext('2d'), img = g.createImageData(w, h), d = img.data, RAMP = ['mu', 'pa2', 'pa', 'pa', 'hw'].map((k) => RGB[k]);
    const put = (x, y, rgb) => { if (x < 0 || y < 0 || x >= w || y >= h) return; const i = (y * w + x) * 4; d[i] = rgb[0]; d[i + 1] = rgb[1]; d[i + 2] = rgb[2]; d[i + 3] = 255; };
    const fold = Math.round(h * 0.5);
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      let l = 0.63 + (vnoise(x * 0.12, y * 0.12, 3) - 0.5) * 0.11;
      const e = Math.min(x, y, w - 1 - x, h - 1 - y); if (e < 2) l -= (2 - e) * 0.13;
      const sx = (x - w * 0.8) / (w * 0.15), sy = (y - h * 0.11) / (w * 0.15), sd = Math.sqrt(sx * sx + sy * sy);
      if (Math.abs(sd - 1) < 0.1) l -= 0.14;
      if (y === fold - 1) l += 0.12; if (y === fold) l -= 0.12;
      if (hash(x, y, 9) > 0.988) l -= 0.22;
      l -= (y / h) * 0.04;
      put(x, y, RAMP[Math.max(0, Math.min(4, Math.floor(l * 4 + (bay(x, y) - 0.5) * 0.7)))]);
    }
    /* the printed parts: a double rule under the heading with a diamond at each end, the likeness frame, a rule over the reward */
    const X = (u) => Math.round(u * (w - 1)), Y = (v) => Math.round(v * (h - 1)), K1 = RGB.k1, HB = RGB.hb;
    for (let x = X(0.13); x <= X(0.87); x++) { put(x, Y(LAY.rule1), K1); put(x, Y(LAY.rule1b), K1); }
    [X(0.1), X(0.9)].forEach((cx) => { const cy = Math.round((Y(LAY.rule1) + Y(LAY.rule1b)) / 2); put(cx, cy, K1); put(cx - 1, cy, K1); put(cx + 1, cy, K1); put(cx, cy - 1, K1); put(cx, cy + 1, K1); });
    const Fr = LAY.frame, fx0 = X(Fr[0]), fy0 = Y(Fr[1]), fx1 = X(Fr[2]), fy1 = Y(Fr[3]);
    for (let y = fy0; y <= fy1; y++) for (let x = fx0; x <= fx1; x++) {
      const edge = x === fx0 || x === fx1 || y === fy0 || y === fy1, inner = x === fx0 + 2 || x === fx1 - 2 || y === fy0 + 2 || y === fy1 - 2;
      if (edge) put(x, y, K1); else if (inner && x > fx0 + 1 && x < fx1 - 1 && y > fy0 + 1 && y < fy1 - 1) put(x, y, HB);
      else if (x > fx0 + 2 && x < fx1 - 2 && y > fy0 + 2 && y < fy1 - 2 && bay(x, y) < 0.3) put(x, y, RGB.pa2);
    }
    for (let x = X(0.2); x <= X(0.8); x++) put(x, Y(LAY.rule2), K1);
    const mx = X(0.5), my = Y(LAY.rule2); put(mx, my - 1, K1); put(mx, my + 1, K1); put(mx - 1, my, K1); put(mx + 1, my, K1);
    /* Hobb's red wax seal, pressed a little off round */
    const scx = LAY.seal[0] * w, scy = LAY.seal[1] * h, sr = Math.max(2.6, w * 0.062);
    for (let y = Math.floor(scy - sr - 1); y <= Math.ceil(scy + sr + 1); y++) for (let x = Math.floor(scx - sr - 1); x <= Math.ceil(scx + sr + 1); x++) {
      const dx = x + 0.5 - scx, dy = y + 0.5 - scy, dd = Math.sqrt(dx * dx + dy * dy) / (sr * (0.92 + hash(x, y, 21) * 0.16));
      if (dd > 1) continue;
      const lit = -(dx + dy) / sr;
      put(x, y, dd > 0.82 ? RGB.b1 : Math.abs(dd - 0.5) < 0.1 ? RGB.b1 : lit > 0.55 ? RGB.b3 : lit < -0.4 ? RGB.b1 : RGB.b2);
    }
    g.putImageData(img, 0, 0);
  }
  /* an ink blot (the natural 1), in pixels: a pool with a lumpy rim, thinner and bluer at its edge, a wet highlight,
     splashes thrown out round it and a drip running down */
  function paintBlot(cv, r) {
    const w = Math.round(r * 3.2) + 4, h = Math.round(r * 3.6) + 4; cv.width = w; cv.height = h;
    const g = cv.getContext('2d'), img = g.createImageData(w, h), d = img.data, cx = w / 2, cy = r * 1.5 + 2;
    const drops = [];
    for (let k = 0; k < 9; k++) { const a = k / 9 * Math.PI * 2 + hash(k, 1, 33) * 0.6, dd = 1.2 + hash(k, 2, 33) * 0.4; drops.push([Math.cos(a) * dd, Math.sin(a) * dd * 0.9, 0.09 + hash(k, 3, 33) * 0.12]); }
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const dx = (x + 0.5 - cx) / r, dy = (y + 0.5 - cy) / r, a = Math.atan2(dy, dx);
      const rr = 1 + 0.14 * Math.sin(a * 3 + 1.3) + 0.09 * Math.sin(a * 5 + 0.4) + 0.05 * Math.sin(a * 11);
      const q = Math.sqrt(dx * dx + dy * dy) / rr;
      let on = q < 1, edge = q > 0.78;
      if (!on && dx > -0.32 && dx < -0.06 && dy > 0.6 && dy < 1.65 - Math.abs(dx + 0.19) * 2) { on = true; edge = dy > 1.4; }
      if (!on) for (const p of drops) { const ex = dx - p[0], ey = dy - p[1]; if (ex * ex + ey * ey < p[2] * p[2]) { on = true; edge = true; break; } }
      if (!on) continue;
      const hi = (dx + 0.34) * (dx + 0.34) + (dy + 0.36) * (dy + 0.36) < 0.03;
      const c = hi ? [86, 88, 132] : edge ? [44, 40, 74] : [20, 16, 32];
      const i = (y * w + x) * 4; d[i] = c[0]; d[i + 1] = c[1]; d[i + 2] = c[2]; d[i + 3] = edge && hash(x, y, 34) > 0.7 ? 200 : 255;
    }
    g.putImageData(img, 0, 0);
  }

  /* ---------- the likeness: the reader's own picture, inked into the poster's frame ---------- */
  /* the inked picture's size: about the frame's own shape (it is 1.5 to 1.64 wide on the posters the scene draws; the
     canvas covers it, so at most a few percent is cropped) and sharp on the saved card, where the frame is 190 to 380 px */
  const LIKE_W = 360, LIKE_H = 230, LIKE_KEY = 'ffd-bounty-likeness', LIKE_MAX = 1024;
  /* inside the frame's inner rule (paintPaper above: the outer edge, a gap, the inner rule, then the picture), as shares
     of the poster */
  function likeRect(w, h) {
    const X = (u) => Math.round(u * (w - 1)), Y = (v) => Math.round(v * (h - 1)), Fr = LAY.frame;
    const x0 = X(Fr[0]) + 3, y0 = Y(Fr[1]) + 3, x1 = X(Fr[2]) - 3, y1 = Y(Fr[3]) - 3;
    return { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h };
  }
  /* the poster's sepia, dark to light: the WANTED ink, the frame's brown, a warm mid and the paper itself */
  const SEPIA = [[0, [34, 20, 12]], [0.36, [92, 59, 39]], [0.7, [178, 152, 118]], [1, [232, 224, 208]]];
  function sepia(L) {
    for (let k = 1; k < SEPIA.length; k++) {
      if (L <= SEPIA[k][0]) { const a = SEPIA[k - 1], b = SEPIA[k], t = (L - a[0]) / (b[0] - a[0]); return [a[1][0] + (b[1][0] - a[1][0]) * t, a[1][1] + (b[1][1] - a[1][1]) * t, a[1][2] + (b[1][2] - a[1][2]) * t]; }
    }
    return SEPIA[SEPIA.length - 1][1];
  }
  /* the picture at the fit's zoom and centre (v: z from 1, cx and cy in the picture's own 0..1), levelled to its own
     darkest and lightest, a little contrast, a fixed grain (so nothing shimmers while it's dragged) and edges that fade
     into the paper, then mapped onto the sepia */
  function inkLike(dst, src, v) {
    const W = LIKE_W, H = LIKE_H;
    if (dst.width !== W) dst.width = W; if (dst.height !== H) dst.height = H;
    const g = dst.getContext('2d', { willReadFrequently: true });
    const s = Math.max(W / src.width, H / src.height) * v.z, dw = src.width * s, dh = src.height * s;
    g.fillStyle = '#fff'; g.fillRect(0, 0, W, H);
    g.imageSmoothingEnabled = true; try { g.imageSmoothingQuality = 'high'; } catch (e) { /* older canvas */ }
    g.drawImage(src, W / 2 - v.cx * dw, H / 2 - v.cy * dh, dw, dh);
    const img = g.getImageData(0, 0, W, H), d = img.data, n = W * H, Ls = new Float32Array(n), hist = new Uint32Array(256);
    for (let i = 0, p = 0; p < n; i += 4, p++) { const l = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; Ls[p] = l; hist[l | 0]++; }
    let lo = 0, hi = 255, acc = 0;
    for (let k = 0; k < 256; k++) { acc += hist[k]; if (acc >= n * 0.02) { lo = k; break; } }
    acc = 0;
    for (let k = 255; k >= 0; k--) { acc += hist[k]; if (acc >= n * 0.02) { hi = k; break; } }
    if (hi - lo < 48) { const m = (hi + lo) / 2; lo = Math.max(0, m - 24); hi = Math.min(255, m + 24); }
    for (let p = 0, i = 0; p < n; p++, i += 4) {
      const x = p % W, y = (p / W) | 0;
      let L = Math.min(1, Math.max(0, (Ls[p] - lo) / (hi - lo)));
      /* a little more contrast in the middle, and the lightest skin keeps a breath of ink */
      L = 0.92 * (0.7 * L + 0.3 * L * L * (3 - 2 * L));
      L += (hash(x, y, 77) - 0.5) * 0.05;
      /* an oval vignette: the sides keep their ink, the corners fade into the paper like an old engraving */
      const ox = (x + 0.5 - W / 2) / (W / 2), oy = (y + 0.5 - H / 2) / (H / 2), r = Math.sqrt(ox * ox + oy * oy);
      const e = Math.min(1, Math.max(0, (1.36 - r) / 0.44)), ee = e * e * (3 - 2 * e);
      L = 1 - (1 - Math.min(1, Math.max(0, L))) * ee;
      const c = sepia(L);
      d[i] = c[0]; d[i + 1] = c[1]; d[i + 2] = c[2]; d[i + 3] = 255;
    }
    g.putImageData(img, 0, 0);
    return dst;
  }
  /* kept in this browser only: the inked picture as a small JPEG with the character's name, never the original */
  const sameName = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase() && !!String(a || '').trim();
  function likeStored() {
    try {
      const o = JSON.parse(localStorage.getItem(LIKE_KEY) || 'null');
      return o && typeof o.name === 'string' && typeof o.img === 'string' && /^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(o.img) && o.img.length < 160000 ? o : null;
    } catch (e) { return null; }
  }
  function likeKeep(name, cv) {
    let url = '';
    for (const q of [0.84, 0.74, 0.62]) { try { url = cv.toDataURL('image/jpeg', q); } catch (e) { url = ''; } if (url && url.length <= 90000) break; }
    if (!/^data:image\/jpeg;base64,/.test(url) || url.length > 120000) return false;
    try { localStorage.setItem(LIKE_KEY, JSON.stringify({ v: 1, name: String(name || '').slice(0, 80), img: url, at: Date.now() })); return true; } catch (e) { return false; }
  }
  function likeForget() { try { localStorage.removeItem(LIKE_KEY); } catch (e) { /* fine */ } }
  function imgFrom(url) { return new Promise((res, rej) => { const im = new Image(); im.decoding = 'async'; im.onload = () => res(im); im.onerror = () => rej(new Error('image')); im.src = url; }); }
  /* a picked file, read on the device and shrunk at once (1024 px at most), so a phone photo doesn't hold memory */
  async function readPicture(file) {
    if (!file || (file.type && !/^image\//.test(file.type))) throw new Error('type');
    if (file.size > 30 * 1024 * 1024) throw new Error('size');
    const url = URL.createObjectURL(file);
    try {
      const im = await imgFrom(url);
      const sw = im.naturalWidth || im.width, sh = im.naturalHeight || im.height;
      if (!sw || !sh) throw new Error('empty');
      const k = Math.min(1, LIKE_MAX / Math.max(sw, sh)), cv = document.createElement('canvas');
      cv.width = Math.max(1, Math.round(sw * k)); cv.height = Math.max(1, Math.round(sh * k));
      const g = cv.getContext('2d'); g.imageSmoothingEnabled = true; try { g.imageSmoothingQuality = 'high'; } catch (e) { /* fine */ }
      g.drawImage(im, 0, 0, cv.width, cv.height);
      return cv;
    } finally { URL.revokeObjectURL(url); }
  }

  FFD.page({
    id: 'bounty', order: 1, section: 'reworked', kind: 'toy',
    title: 'a price on your character’s head',
    hook: 'Tell the sheriff what your character did. The dice set the reward.',
    thumb: { key: KEY, set: { paper: 2, mock: 1, cast: 'swords' } },
    async render(ctx) {
      injectCSS();
      const h = ctx.h, S = window.FFSound;
      let dm = false, roundN = 0, hobbBusy = false;
      /* whose poster this is: the reader's own character, or a DM's player's (a guest from F.char({ guest: true }), never
         saved, so FFD.char stays the reader's own). The page's own words name whoever is on the poster */
      let posterOf = null;
      const fmt = (s) => (FFD.fmt ? FFD.fmt(s, posterOf || undefined) : ctx.fmt(s));
      /* the egg kit (core.js): the snail climbs the wet board one notch for each day this page was opened, from the second
         on, and on the seventh Hobb chalks it on his slate */
      const EG = FFD.egg ? FFD.egg('bounty') : null;
      const days = FFD.visitDays ? FFD.visitDays('bounty') : 0, snailUp = Math.max(0, Math.min(6, days - 1)), snailChalk = days >= 7;
      let snailSaid = false, hallOff = false;
      const P = {};                                       /* what is on the poster so far */
      /* everyone's posters and gold (a few were up before anyone played), and whether this reader's poster is on the board */
      const TL = FFD.tally;
      TL.base('bounty', 'posted', 4); TL.base('bounty', 'gold', 1150); if (TL.cap) TL.cap('bounty', 'gold', 50000);
      const posted = () => TL.total('bounty', 'posted'), goldAll = () => TL.total('bounty', 'gold');
      let mineUp = false, chalking = false, slateN = goldAll();
      const stackNow = () => Math.max(0, posted() - (mineUp ? 1 : 0));
      const turn = {};                                    /* where each cycling list is up to */
      const next = (id, list) => { turn[id] = (turn[id] == null ? -1 : turn[id]) + 1; return list[turn[id] % list.length]; };

      /* one bubble at a time; the frame keeps them off the corner bar */
      const bark = (target, text, bo) => { F.hush(); return F.bark(target, text, bo); };
      /* the ending is the Quest button and one quiet row: the save chip the frame adds joins that row */
      const quietEnd = async () => {
        for (let i = 0; i < 80 && ctx.alive() && !F.acts.querySelector('.is-quest'); i++) await new Promise((r) => setTimeout(r, 25));
        F.acts.querySelectorAll('.ffs-chip:not(.is-quest)').forEach((b) => b.classList.add('is-quiet'));
      };
      /* a Hall hero in the box: the name and, in the review demo, the painted portrait (the frame gives it the Hall's
         gold ring). On the store there is no demo hero list or portrait path, so the box gets the name alone */
      const heroWho = (id) => {
        const x = !FFD.live && (window.FFD_HEROES || []).find((hr) => hr.slug === id);
        return x ? { name: x.name.replace(/"([^"]*)"/g, '“$1”'), img: x.img } : { name: HERO_NAMES[id] || 'A hunter' };
      };
      /* a bark over a spot; things that leave (the cat) get theirs at the point where they were */
      const barkAt = (id, line, o) => {
        o = o || {};
        const item = typeof line === 'string' ? { text: line } : line;
        const who = item.who || o.who;
        let target = id;
        if (o.fixed) { const hs = F.api && F.api.hot ? F.api.hot(KEY) : null, sp = hs && hs.spots[id]; if (sp) target = { x: sp.x + sp.w / 2, y: sp.y }; }
        const bo = Object.assign({ tone: who ? null : 'quiet' }, who ? { who: { name: who } } : {}, o.ms ? { ms: o.ms } : {}, o.below ? { below: true } : {});
        return bark(target, item.text, bo);
      };

      /* ---- the things in the picture ---- */
      const hots = {
        lantern: { label: 'The lantern', sound: false, tap: () => { F.act('swing'); barkAt('lantern', next('lantern', LANTERN)); } },
        hobb: { label: 'Sheriff Hobb', sound: 'pat', tap: () => { F.act('hobb'); barkAt('hobb', next('hobb', HOBB), { who: 'Sheriff Hobb' }); } },
        hammer: { label: 'Hobb’s hammer', sound: false, tap: () => {
          if (hobbBusy) { S && S.pat(); barkAt('hobb', '“Busy,” says Hobb, without looking up.'); return; }
          F.act('rap'); barkAt('hobb', next('rap', RAP), { ms: 2600 });
        } },
        poster: { label: 'The poster', sound: false, tap: () => { F.act('flutter'); barkAt('poster', next('poster', POSTER)); } },
        patch: { label: 'The bare patch on the board', sound: 'rustle', tap: () => barkAt('patch', next('patch', PATCH)) },
        oldposter: { label: 'The missing notice', sound: 'rustle', tap: () => { F.act('old'); barkAt('oldposter', next('old', OLD)); } },
        tabs: { label: 'The notice with the tabs', sound: false, tap: () => {
          const left = F.get('tabsLeft') | 0;
          if (left > 0) { F.act('tab'); barkAt('tabs', left === 1 ? TABS_DONE : next('tabs', TABS)); }
          else { S && S.pat(); barkAt('tabs', TABS_DONE); }
        } },
        notice: { label: 'The sheriff’s notice', sound: 'chime', tap: () => { F.act('seal'); barkAt('notice', next('notice', NOTICE)); } },
        slate: { label: 'Hobb’s slate', sound: 'pat', tap: () => {
          if (snailChalk && !snailSaid) { snailSaid = true; barkAt('slate', SNAIL_LINE, { below: true, who: 'Sheriff Hobb' }); return; }
          barkAt('slate', next('slate', SLATE), { below: true });
        } },
        cat: { label: 'The cat', sound: false, tap: () => { F.act('cat'); barkAt('cat', next('cat', CAT), { fixed: true }); } }
      };
      /* the hunters get their handlers when they arrive, and lose them when they go */
      function huntersOn(cast, C) {
        const map = {};
        C.who.forEach((name, k) => {
          map['h' + k] = { label: name, sound: 'pat', tap: (id) => { F.act('look', k); barkAt(id, next(cast + k, C.barks[k] || ['“Not now.”']), { who: name }); } };
        });
        F.hots(map, { merge: true });
      }
      function huntersOff() { for (let k = 0; k < 6; k++) F.hot('h' + k, null); }

      /* ---- the frame ---- */
      const F = ctx.frame({
        key: KEY, title: this.title, line: 'Put your character on Sheriff Hobb’s wanted poster. The reward decides who comes hunting.',
        alt: 'Marrow’s End’s notice board at night under its own little roof, a lantern burning at one corner, old notices round a bare space in the middle and Sheriff Hobb standing by with his hammer.',
        /* snailUp: the egg kit's week on the board (see days); a first visit sends nothing */
        set: Object.assign({ paper: 0, cast: null, mock: 0, scraps: 0, tabsTorn: 0, stack: stackNow(), heroOk: heroesOk() }, snailUp ? { snailUp } : {}),
        hots,
        onEmit: (type, d) => { if (type === 'impact') impact(d); },
        tapArt: () => F.act('knock')
      });
      /* the first time the chalked snail is up, Hobb says so over his slate (later, a touch of the slate does) */
      if (snailChalk && EG && !EG.get('chalked', false)) F.ready.then(() => setTimeout(() => {
        if (!ctx.alive() || snailSaid || hobbBusy || F.el.classList.contains('has-sheet')) return;
        snailSaid = true; EG.set('chalked', FFD.day()); barkAt('slate', SNAIL_LINE, { below: true, who: 'Sheriff Hobb' });
      }, RM() ? 200 : 1600)).catch(() => {});
      /* the eggs: the cat and Hobb's tin, the snail (eggKit above), on whenever the board is free to touch */
      const eggs = eggKit(F, ctx, { hold: () => hobbBusy, eggs: { 'egg-tin': { label: 'A tin of nails' }, 'egg-snail': { label: 'A snail on the wet board' } } });
      F.hots(eggs.hots, { merge: true });
      F.on('egg', (d) => eggSnd(d && d.beat));

      /* ---- under the frame: the DM's hunters, one question, the notes (there from the start) ---- */
      const after = ctx.block('ffd-after');
      reference(after);

      await F.ready;
      if (!ctx.alive()) return;

      /* ---- the poster itself, laid inside the art under the canvas ---- */
      const art = F.art;
      const poster = h('div', { class: 'bnt-poster', 'aria-hidden': 'true' });
      const paper = h('canvas', { class: 'bnt-paper' });
      const elWanted = h('div', { class: 'bnt-p bnt-p-wanted', text: 'Wanted' });
      const elName = h('div', { class: 'bnt-p bnt-p-name' });
      const elClass = h('div', { class: 'bnt-p bnt-p-class' });
      const elLike = h('div', { class: 'bnt-p bnt-p-like' }, h('span', { text: 'No likeness' }), h('span', { text: 'on file' }));
      const elFor = h('div', { class: 'bnt-p bnt-p-for' });
      const elCharge = h('div', { class: 'bnt-p bnt-p-charge' });
      const elRL = h('div', { class: 'bnt-p bnt-p-rlabel', text: 'Reward' });
      const elReward = h('div', { class: 'bnt-p bnt-p-reward' });
      const elFoot = h('div', { class: 'bnt-p bnt-p-foot', text: 'By order of the Sheriff of Marrow’s End' });
      const blot = h('canvas', { class: 'bnt-blot' });
      /* the likeness: drawn from `like` (the inked canvas) whenever this poster's character has one */
      const pic = h('canvas', { class: 'bnt-pic', width: String(LIKE_W), height: String(LIKE_H) });
      let like = null, likeOn = false;
      poster.append(paper, elWanted, elName, elClass, elLike, pic, elFor, elCharge, elRL, elReward, elFoot, blot);
      art.insertBefore(poster, art.firstChild);
      /* the slate's number, everyone's gold, chalked */
      const slateNum = h('b', { text: slateN.toLocaleString('en-US') });
      slateNum.dataset.n = String(slateN);
      /* the seventh day: Hobb has chalked the snail beside the sum (no letters, chalk pixels) */
      const slateEl = h('div', { class: 'bnt-slate', 'aria-hidden': 'true' }, snailChalk ? h('span', { class: 'bnt-slate-row' }, slateNum, chalkSnail()) : slateNum, h('small', { text: 'gold on heads' }));
      art.insertBefore(slateEl, art.firstChild);
      const placeSlate = () => {
        const r = F.spotCss('slate');
        if (!r) { slateEl.classList.remove('is-in'); return; }
        /* the spot is the slate's face plus two pixels round it: the face is what the canvas leaves see-through */
        const pad = 2 * (F.toCss(1, 0).x - F.toCss(0, 0).x);
        /* the sum and its two small lines stand about 2.7em tall, so a short slate (a short phone) sets a smaller size. With
           the chalk snail beside the sum (the seventh day) the row is about 3.9em wide, so it sets the size too */
        const iw = Math.max(10, r.w - pad * 2), ih = Math.max(10, r.h - pad * 2);
        Object.assign(slateEl.style, { left: (r.x + pad) + 'px', top: (r.y + pad) + 'px', width: iw + 'px', height: ih + 'px', fontSize: Math.max(9, Math.min(18, r.w / (snailChalk ? 5.4 : 4.4), ih / 2.6)) + 'px' });
        slateEl.classList.add('is-in');
      };
      /* other players' posters, live, thicken the stack and grow the slate's sum */
      ctx.onKill(TL.on(() => {
        F.set('stack', stackNow());
        const n = goldAll();
        if (!chalking && n > slateN) { slateN = n; FFD.countUp(slateNum, n); }
      }));
      let lastGeo = '', lastBox = '';
      const geoNow = () => {
        const cvs = art.querySelectorAll('canvas.qo-scenes__cv'), cv = cvs[cvs.length - 1], geo = F.get('geo');
        if (!cv || !geo || cv.width !== geo.W || !cv.style.width) return null;
        const kc = parseFloat(cv.style.width) / cv.width;
        return { cv, geo, kc, left: parseFloat(cv.style.left) + geo.x * kc, top: parseFloat(cv.style.top) + geo.y * kc, w: geo.w * kc, h: geo.h * kc };
      };
      const place = () => {
        const G = geoNow(); if (!G) return;
        const gk = G.geo.w + 'x' + G.geo.h;
        if (gk !== lastGeo) {
          lastGeo = gk; paintPaper(paper, G.geo.w, G.geo.h); fitText();
          const r = likeRect(G.geo.w, G.geo.h);
          Object.assign(pic.style, { left: r.x * 100 + '%', top: r.y * 100 + '%', width: r.w * 100 + '%', height: r.h * 100 + '%' });
        }
        const bk = [G.left, G.top, G.w, G.h].map((v) => Math.round(v * 100) / 100).join(',');
        if (bk === lastBox) return;
        lastBox = bk;
        Object.assign(poster.style, { left: G.left + 'px', top: G.top + 'px', width: G.w + 'px', height: G.h + 'px', fontSize: (G.w / 12.4) + 'px' });
        poster.classList.toggle('is-small', G.w < 260);
        fitText();
      };
      const loop = () => { if (!ctx.alive()) return; place(); placeSlate(); requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
      /* a line too long for the poster shrinks until it fits */
      const textW = (el) => [...el.children].reduce((a, c) => a + c.getBoundingClientRect().width, 0);
      function fit(el, max, lines) {
        el.style.fontSize = '';
        if (!el.textContent) return;
        const box = poster.getBoundingClientRect().width * max;
        for (let k = 0; k < 14; k++) {
          const over = lines ? el.scrollHeight > el.clientHeight + 1 : textW(el) > box;
          if (!over) break;
          el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * 0.92) + 'px';
        }
      }
      function fitText() { fit(elName, 0.88); fit(elCharge, 1, true); fit(elReward, 0.66); }
      /* ink going onto the poster */
      function ink(el, text, ms) {
        el.textContent = '';
        const sp = h('span', { class: 'bnt-ink bnt-wet', text });
        el.append(sp); fitText();
        sp.style.setProperty('--bnt-ms', (RM() ? 0 : ms) + 'ms');
        requestAnimationFrame(() => requestAnimationFrame(() => sp.classList.add('is-in')));
        S && S.pen();
        if (!RM() && ms > 450) setTimeout(() => S && S.pen(), ms * 0.55);
        setTimeout(() => sp.classList.remove('bnt-wet'), 400);
        return ctx.wait(RM() ? 60 : ms + 80);
      }
      async function inkWords(el, text) {
        el.textContent = '';
        const box = h('span');
        /* the spaces sit between the word spans: inside an inline-block a leading space would collapse */
        const words = text.split(' ').map((w) => h('span', { class: 'bnt-word bnt-wet', text: w }));
        words.forEach((w, i) => { if (i) box.append(' '); box.append(w); });
        el.append(box); fitText();
        if (RM()) { words.forEach((w) => w.classList.add('is-in')); return; }
        for (let i = 0; i < words.length; i++) {
          words[i].classList.add('is-in');
          if (i % 2 === 0) S && S.pen();
          await ctx.wait(70 + words[i].textContent.length * 22);
        }
        setTimeout(() => words.forEach((w) => w.classList.remove('bnt-wet')), 600);
      }
      function clearPoster() {
        [elName, elClass, elFor, elCharge, elReward].forEach((el) => { el.textContent = ''; el.style.fontSize = ''; });
        blot.classList.remove('is-in');
        Object.keys(P).forEach((k) => delete P[k]);
        /* a fresh poster starts with an empty frame; fill() inks the likeness back once the same name is on it */
        pic.classList.remove('is-on', 'bnt-ink', 'is-in'); elLike.classList.remove('is-pic'); likeOn = false;
      }
      /* the likeness on the poster, or the empty frame again; inked on left to right like the words */
      function showLike(on, animate) {
        on = !!(on && like);
        if (on) { const g = pic.getContext('2d'); g.clearRect(0, 0, LIKE_W, LIKE_H); g.drawImage(like.cv, 0, 0, LIKE_W, LIKE_H); }
        pic.classList.remove('bnt-ink', 'is-in');
        pic.classList.toggle('is-on', on); elLike.classList.toggle('is-pic', on);
        likeOn = on;
        if (on && animate && !RM()) {
          pic.style.setProperty('--bnt-ms', '760ms'); pic.classList.add('bnt-ink');
          requestAnimationFrame(() => requestAnimationFrame(() => pic.classList.add('is-in')));
          S && S.pen(); setTimeout(() => S && S.pen(), 420);
        }
        sayAlt();
      }
      /* this character's likeness, from this visit or from this browser (decoded only when the name matches) */
      async function likeFor(c) {
        if (!c || !c.name) return false;
        if (like && sameName(like.name, c.name)) return true;
        const o = likeStored();
        if (!o || !sameName(o.name, c.name)) return false;
        try {
          const im = await imgFrom(o.img), cv = document.createElement('canvas');
          cv.width = LIKE_W; cv.height = LIKE_H; cv.getContext('2d').drawImage(im, 0, 0, LIKE_W, LIKE_H);
          like = { name: c.name, cv };
          return true;
        } catch (e) { return false; }
      }
      /* the reader's own public Hall portrait as the likeness (a reader who took the Quest, never a DM's guest): the hero
         by this name or id in this browser's copy (FFD.quest, public heroes only), loaded crossOrigin so the canvas may
         read it, and inked like an upload but never kept. A refused or failed picture leaves "No likeness on file", and
         an upload always wins */
      function hallPic(c) {
        const Q = FFD.quest;
        if (!c || !c.name || !Q || Q.v !== 1 || !Q.took()) return null;
        const list = [Q.hero()].concat(Q.heroes() || []).filter((x) => x && x.public === true && x.thumb && x.name);
        return list.find((x) => (c.heroId && (x.heroId === c.heroId || x.id === c.heroId)) || sameName(x.name, c.name)) || null;
      }
      async function hallLike(c) {
        const hp = hallPic(c); if (!hp) return false;
        try {
          const im = await new Promise((res, rej) => {
            const i = new Image(); i.crossOrigin = 'anonymous'; i.referrerPolicy = 'no-referrer'; i.decoding = 'async';
            i.onload = () => res(i); i.onerror = () => rej(new Error('image')); i.src = hp.thumb;
          });
          const f = hp.frame || {}, cv = document.createElement('canvas');
          /* the Hall's own framing: its zoom, and where the face sits */
          inkLike(cv, im, { z: Math.max(1, (f.zoom || 100) / 100), cx: (f.x != null ? f.x : 50) / 100, cy: (f.y != null ? f.y : 50) / 100 });
          like = { name: c.name, cv, hall: true };
          return true;
        } catch (e) { return false; }
      }
      function sayAlt() {
        const c = posterOf || FFD.char;
        let t = 'Marrow’s End’s notice board at night, a lantern at one corner, Sheriff Hobb beside it.';
        if (P.hung) t += ' A wanted poster' + (c && P.named ? ' for ' + c.name + ' the ' + c.clsLabel : '') + (likeOn ? ', with ' + (c && P.named ? c.name + '’s' : 'a') + ' likeness inked in its frame' : '') + (P.charge ? ', for ' + P.charge : '') + (P.gold ? ', reward ' + P.goldText + ' gold' : '') + (P.nailed ? ', nailed up' : '') + '.';
        if (P.cast) t += ' Hunters have stopped to read it.';
        art.setAttribute('aria-label', t);
      }
      /* the hammer lands: the page's half of the blow */
      function impact(d) {
        S && S.hammer();
        if (d.last) setTimeout(() => S && S.pat(), 60);
        ctx.fx.shake(art, d.last ? 5 : 3);
        FFD.buzz(d.last ? 24 : 12);
        const p = F.toCss(d.x, d.y), r = art.getBoundingClientRect();
        ctx.fx.sparks(art, { x: r.left + p.x, y: r.top + p.y, n: d.last ? 10 : 6, spread: d.last ? 54 : 38, colors: ['#fff6dc', '#f4d68a', '#e8c674', '#c9ced4'] });
      }

      /* ---- the opening: the DM switch lives here, as the first choice ---- */
      const who = await F.ask([{ label: 'My character', hot: ['patch', 'hobb'] }, { label: 'A player’s character' }], { cols: 2 });
      if (!ctx.alive()) return;
      dm = who.index === 1;

      /* ---- a round: hang a poster, fill it in, nail it up, see who comes; again as often as the reader likes ---- */
      for (;;) {
        roundN++;
        await hang();
        if (!ctx.alive()) return;
        const again = await fill();
        if (!ctx.alive() || !again) return;
        await F.clearActs();
        F.say(['The hunters drift off. {Name}’s poster stays up under the next one.']);
        huntersOff();
        hobbBusy = true;
        F.act('leave');
        await F.once('left', 3200);
        hobbBusy = false;
        /* the reader's poster joins the stack under the next one */
        mineUp = false; F.set('stack', stackNow());
        F.set('paper', 0); F.set('cast', null);
        poster.classList.remove('is-on'); clearPoster(); sayAlt();
        await ctx.wait(RM() ? 0 : 500);
        /* the next poster goes up on the reader's tap, so the words keep step with the board */
        await F.cont();
        if (!ctx.alive()) return;
      }

      async function hang() {
        clearPoster();
        poster.classList.add('is-on');
        F.set('paper', 1); F.act('unroll'); hobbBusy = true;
        const lines = F.say([roundN === 1 ? 'Hobb tacks a fresh poster to the board and dips his pen.' : 'Hobb tacks up another one. He keeps a stack.']);
        await F.once('hung', 4000);
        hobbBusy = false;
        P.hung = true; sayAlt();
        await lines;
      }

      async function fill() {
        /* the name. The reader's own character goes up at once when one is saved (the first poster shows the plate with
           Change; later ones just use it). A DM's player's character is a guest: an empty card each time, written on this
           poster only. The card covers the box on a phone, so the line before it is read first */
        const had = !dm && !!(FFD.char && FFD.char.name);
        if (!had) { await F.cont(); if (!ctx.alive()) return false; }
        let c;
        if (dm) c = await F.char({ guest: true, prompt: 'Which player’s character is it for?', button: 'That’s the one' });
        else if (had && roundN > 1) { F.as(null); c = FFD.char; }
        else c = await F.char({ prompt: 'Whose name goes on the poster?', button: 'That’s my character', again: 'Use {Name}' });
        if (!ctx.alive() || !c) return false;
        posterOf = c;
        P.named = true;
        const named = F.say(['Hobb writes {Name} in his best hand and blows on the ink.']);
        await ctx.wait(RM() ? 0 : 260);
        await ink(elName, c.name, 560);
        elClass.textContent = 'the ' + c.clsLabel;
        sayAlt();
        /* a likeness this character already has (this visit, or kept in this browser) goes back in its frame; with none,
           a reader who took the Quest and has a public Hall hero by this name gets that portrait, inked the same way */
        likeFor(c).then((ok) => {
          if (!ctx.alive() || !P.named || posterOf !== c) return;
          if (ok) { showLike(true, true); return; }
          if (!dm && !hallOff) hallLike(c).then((ok2) => { if (ok2 && ctx.alive() && P.named && posterOf === c && !likeOn) showLike(true, true); });
        });
        await named;

        /* the charge, from a sheet over the art (read on first: it covers the box on a phone); the last choice is the
           reader's own words. A charge already put on a poster stays greyed; their own words never do */
        await F.cont();
        if (!ctx.alive()) return false;
        const opts = CHARGES.map((ch) => ({ label: ch.label, value: ch })).concat([{ label: OWN.label, value: OWN, used: false }]);
        const got = await F.ask(opts, { sheet: true, prompt: 'What did {Name} do?', used: true });
        if (!ctx.alive() || !got) return false;
        const charge = got.value;
        let posterText;
        if (charge === OWN) {
          posterText = await F.sheet((body, close) => {
            const wrap = h('div', { class: 'bnt-own' });
            const inp = h('input', { class: 'ffd-input', id: 'bnt-own-' + roundN, maxlength: '60', autocomplete: 'off', placeholder: fmt('What {they} did') });
            const go = F.chip('Write it down', { solid: true });
            const err = h('p', { class: 'ffd-err', hidden: true });
            const ok = () => { const v = inp.value.trim().replace(/\s+/g, ' '); if (!v) { err.textContent = 'Give Hobb something to write.'; err.hidden = false; ctx.fx.shake(inp, 5); inp.focus(); return; } S && S.tap(); inp.blur(); close(v); };
            go.addEventListener('click', ok); inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); ok(); } });
            wrap.append(inp, err, h('div', { class: 'bnt-own-go' }, go));
            body.append(wrap);
            setTimeout(() => inp.focus({ preventScroll: true }), RM() ? 0 : 320);
          }, { title: 'In your own words' });
          if (!ctx.alive() || !posterText) return false;
          elFor.textContent = 'The charge';
        } else { posterText = charge.poster; elFor.textContent = 'Wanted for'; }
        P.charge = posterText; P.chargePoster = posterText;
        /* Hobb's aside about the charge, one line in the box while the ink goes on (a bubble would sit on the poster);
           the stakes replace it on the reader's tap */
        const noted = F.say([charge.note]);
        await ctx.wait(RM() ? 0 : 200);
        await inkWords(elCharge, posterText);
        sayAlt();
        await noted;

        /* the reward: the stakes first, then the dice over the art (or a tap on the poster rolls them) */
        const base = charge.base;
        const res = await F.roll({
          dice: [{ sides: 20 }, { sides: 6 }, { sides: 6 }], label: 'Roll the reward', hot: 'poster', hold: 1600,
          stakes: 'Hobb starts at ' + base + ' gold and adds 10 for every point rolled. Reach 280 and ' +
            (heroOk('gillic') ? 'Gillic Grimson comes himself.' : 'the ranger who never blinks comes herself.')
        });
        if (!ctx.alive() || !res) return false;
        let gold = base + res.total * 10, cast, line, cls = 'gold';
        await ctx.wait(RM() ? 0 : 500);
        await countUp(base, gold);
        if (res.crit) {
          const g2 = gold * 2;
          await strikeAndDouble(g2);
          line = 'A natural 20. Hobb crosses out ' + gold + ' and writes ' + g2 + '.';
          gold = g2; cast = 'crowd'; cls = 'big';
        } else if (res.fumble) {
          await smudge();
          line = 'A natural 1. Ink blots the number, so it reads 9, 90 or 900. Everybody is coming.';
          cast = 'muddle';
        } else if (gold >= 280) { line = gold + ' gold. Hobb checks his sums twice and whistles through his teeth.'; cast = 'ranger'; }
        else if (gold >= 170) { line = gold + ' gold. Enough to get talked about at the Hollow Stump tonight.'; cast = 'swords'; }
        else { line = gold + ' gold. Hobb calls it a starting price and underlines it.'; cast = 'farm'; }
        P.gold = gold; P.goldNum = res.fumble ? 90 : gold; P.goldText = res.fumble ? '9, 90 or 900' : String(gold); sayAlt();
        await F.say([{ text: line, cls }]);

        /* the nails: the chip, or a tap on the poster, the hammer or Hobb */
        /* the poster, the hammer or Hobb all nail it up; the beacon shows the poster */
        const bt = setTimeout(() => { if (ctx.alive()) F.beacon('poster'); }, RM() ? 300 : 1800);
        await F.next('Nail it to the board', { hot: ['poster', 'hammer', 'hobb'], beacon: false });
        clearTimeout(bt); F.beacon('poster', false);
        if (!ctx.alive()) return false;
        S && S.wake();
        F.set('paper', 2); F.act('nail'); hobbBusy = true;
        await F.once('nailed', 4200);
        await ctx.wait(RM() ? 0 : 600);
        hobbBusy = false;
        P.nailed = true; sayAlt();

        /* everyone's tally gains this poster, and Hobb walks to his slate and chalks the new sum. The going rate is
           everyone else's average, read before this one counts */
        const avg = Math.round(goldAll() / Math.max(1, posted()));
        const add = P.goldNum;
        mineUp = true; chalking = true;
        TL.add('bounty', 'posted'); TL.add('bounty', 'gold', add);
        F.set('stack', stackNow());
        hobbBusy = true;
        const pCh = F.once('chalked', 4200);
        F.act('chalk');
        await pCh;
        if (!ctx.alive()) return false;
        hobbBusy = false; chalking = false;
        slateN = goldAll(); FFD.countUp(slateNum, slateN); ctx.fx.pop(slateEl, '+' + add);
        const rate = res.fumble ? '“I’ve chalked it as 90, to be safe. Nobody can read the noughts.”'
          : add >= avg * 1.25 ? '“Well over the going rate of ' + avg + ". I’ve underlined it twice.”"
          : add <= avg * 0.8 ? '“Under the going rate of ' + avg + '. I’ll write the number bigger.”'
          : '“About the going rate in Marrow’s End. ' + avg + ', give or take.”';
        /* on a phone the poster fills the picture and a bubble under the slate lands on the name, so the line goes in the
           box under Hobb's name instead. Either way the hunters arrive on the reader's tap */
        if (window.matchMedia && matchMedia('(min-width: 720px)').matches) barkAt('slate', { text: rate, who: 'Sheriff Hobb' }, { below: true, ms: 4200 });
        else await F.say([{ text: rate, cls: 'say' }], { who: { name: 'Sheriff Hobb' } });
        await F.cont();
        if (!ctx.alive()) return false;

        /* who comes */
        /* the Hall heroes allowed right now, for the box and the picture alike */
        const C = castOf(cast);
        F.set('heroOk', heroesOk());
        const arrive = F.say([C.arrive]);
        await ctx.wait(RM() ? 0 : 350);
        F.set('cast', cast); F.act('hunters', cast);
        huntersOn(cast, C);
        P.cast = cast; sayAlt();
        await Promise.all([arrive, F.once('arrived', 3800)]);
        /* a Hall hero's line puts their name and painted portrait in the box, and anyone else's adds to what's there.
           On a phone the poster fills the picture and a bubble over a hunter's head lands on the name, so there the
           spoken line goes in the box under its speaker instead (a tap on a hunter still gets a bubble). */
        const narrow = !(window.matchMedia && matchMedia('(min-width: 720px)').matches);
        let boxWho = '';
        for (const ln of C.lines) {
          if (!ctx.alive()) return false;
          if (ln.talk != null) F.act('look', ln.talk);
          if (ln.cheer) F.act('cheer', ln.talk);
          if (ln.bark && !narrow) { barkAt('h' + ln.talk, ln.bark, { who: C.who[ln.talk] }); await ctx.wait(RM() ? 0 : 900); }
          const spoken = ln.bark && narrow ? { text: ln.bark, cls: 'say' } : null;
          if (ln.hero && (spoken || ln.text)) { const w = heroWho(ln.hero); boxWho = w.name; await F.say([spoken, ln.text].filter(Boolean), { who: w }); }
          else if (spoken && C.who[ln.talk] !== boxWho) { boxWho = C.who[ln.talk]; await F.say([spoken].concat(ln.text ? [ln.text] : []), { who: { name: boxWho } }); }
          else if (spoken || ln.text) await F.say([spoken, ln.text].filter(Boolean), { add: true });
          /* on a wide screen the next bubble takes this one's place, so each beat waits for the reader's tap; on a phone
             every line is in the box, which waits for the tap by itself before it takes a line away */
          if (narrow) await ctx.wait(RM() ? 0 : ln.bark ? 1500 : 650); else await F.cont();
        }
        /* the last line is read before the board moves on */
        await F.cont();
        if (!ctx.alive()) return false;

        /* the first time: the missing notice beside it */
        if (roundN === 1) {
          F.act('old');
          await F.say(['Beside it, a notice for twelve lost on the Hollow Stump road. Nobody has taken that job.']);
          await F.cont();
          if (!ctx.alive()) return false;
        }

        /* the end of the round: the line about the face leads into one Quest button, then keep the poster or post another
           (no bubble over the poster, so nothing covers it on a short phone) */
        const endP = F.end({
          /* the frame fills {Name} (escaped, and the guest's on a DM's poster) */
          lines: ['{Name} is worth ' + P.goldText + ' gold in Marrow’s End now.'],
          shared: [{ n: goldAll(), plus: P.goldNum, text: '{n} gold on heads' }, { n: posted(), plus: 1, text: '{n} posters up' }],
          /* one line over the Quest button: nobody has seen the face yet, which is what the Quest gives a character (with
             a likeness on the poster, the hunters know the face now: leadLine) */
          leadIn: leadLine(),
          /* a reader who took the Quest isn't sold it: with a face on the poster, the line that the hunters know it stays */
          takenLeadIn: !dm && likeOn ? leadLine() : undefined,
          /* a DM's poster is a player's character: the button stays plain, as the lead-in asks for the DM's own */
          named: !dm,
          save: { button: dm ? 'Save it to send' : 'Save the poster', alt: 'A wanted poster for ' + c.name, draw: (g, W, H) => drawCard(g, W, H, c) },
          again: 'Post another'
        });
        quietEnd().then(() => likeChips(c));
        const end = await endP;
        return end === 'again';
      }

      /* ---- the likeness: the end row's chips, the fit sheet ---- */
      function leadLine() {
        if (dm) return 'Send the poster on, then bring your own character.';
        return likeOn ? 'Every hunter in Marrow’s End knows {Name}’s face now.' : 'Nobody in Marrow’s End has seen {Name}’s face yet.';
      }
      /* "Add a likeness", or "Change the likeness" and "Remove it", quiet in the end row before "Save the poster" */
      function likeChips(c) {
        if (!ctx.alive() || !F.acts.querySelector('.is-quest')) return;
        F.acts.querySelectorAll('.bnt-like-c').forEach((b) => b.remove());
        const before = [...F.acts.querySelectorAll('.ffs-chip')].find((b) => !b.classList.contains('is-quest')) || null;
        const add = F.chip(likeOn ? 'Change the likeness' : 'Add a likeness', { quiet: true, i: 1 });
        add.classList.add('bnt-like-c');
        add.addEventListener('click', () => pickLike(c));
        F.acts.insertBefore(add, before);
        if (likeOn) {
          const rm = F.chip('Remove it', { quiet: true, i: 1 });
          rm.classList.add('bnt-like-c'); rm.setAttribute('aria-label', 'Remove the likeness');
          rm.addEventListener('click', () => {
            S && S.rustle && S.rustle();
            /* the Hall portrait was never kept, so taking it off keeps any upload this browser holds, and it stays off */
            if (like && like.hall) hallOff = true; else likeForget();
            like = null; showLike(false);
            afterLike(c);
          });
          F.acts.insertBefore(rm, before);
        }
      }
      /* the lead-in follows the face, the chips follow the state, and the focus stays in the row */
      function afterLike(c) {
        const lead = F.acts.querySelector('.ffs-lead');
        if (lead) lead.textContent = fmt(leadLine());
        likeChips(c);
        const first = F.acts.querySelector('.bnt-like-c');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      }
      /* the device's own picker (a hidden file input, clicked inside the tap), then the fit sheet */
      function pickLike(c) {
        const inp = h('input', { type: 'file', accept: 'image/*', tabindex: '-1', 'aria-hidden': 'true', style: 'position:fixed;left:-9999px;width:1px;height:1px;opacity:0' });
        const drop = () => setTimeout(() => inp.remove(), 0);
        inp.addEventListener('change', () => {
          const file = inp.files && inp.files[0]; drop();
          if (file && ctx.alive()) fitLike(c, file);
        });
        inp.addEventListener('cancel', drop);
        document.body.append(inp);
        S && S.tap && S.tap();
        inp.click();
      }
      async function fitLike(c, file) {
        let src = null;
        const view = { z: 1, cx: 0.5, cy: 0.5 };
        const got = await F.sheet((body, close) => {
          const wrap = h('div', { class: 'bnt-fit' });
          const cv = h('canvas', { width: String(LIKE_W), height: String(LIKE_H), 'aria-hidden': 'true' });
          const wait = h('p', { class: 'bnt-fit-wait', text: 'Inking…' });
          const box = h('div', { class: 'bnt-fit-view', tabindex: '0', role: 'img', 'aria-label': 'The likeness in the poster’s frame. Drag or use the arrow keys to move it, and plus or minus to zoom.' }, cv, wait);
          const svg = (d) => '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
          const zOut = h('button', { type: 'button', class: 'bnt-fit-zb', 'aria-label': 'Zoom out', html: svg('M3 8h10') });
          const zIn = h('button', { type: 'button', class: 'bnt-fit-zb', 'aria-label': 'Zoom in', html: svg('M3 8h10M8 3v10') });
          const range = h('input', { type: 'range', min: '100', max: '400', step: '1', value: '100', 'aria-label': 'Zoom' });
          const tip = h('p', { class: 'bnt-fit-tip', text: 'Drag to move it. Pinch or slide to zoom.' });
          const note = h('p', { class: 'bnt-fit-note', text: 'It stays on this device. Nothing is uploaded.' });
          const use = F.chip('Use it', { solid: true }), other = F.chip('Another picture'), no = F.chip('Cancel', { quiet: true });
          use.disabled = true;
          wrap.append(box, h('div', { class: 'bnt-fit-zoom' }, zOut, range, zIn), tip, note, h('div', { class: 'bnt-fit-go' }, use, other, no));
          body.append(wrap);
          /* keep the picture covering the frame: the centre can't go past the picture's edges at this zoom */
          const clamp = () => {
            if (!src) return;
            view.z = Math.min(4, Math.max(1, view.z));
            const s = Math.max(LIKE_W / src.width, LIKE_H / src.height) * view.z;
            const hw = LIKE_W / 2 / (src.width * s), hh = LIKE_H / 2 / (src.height * s);
            view.cx = Math.min(1 - hw, Math.max(hw, view.cx)); view.cy = Math.min(1 - hh, Math.max(hh, view.cy));
          };
          let raf = 0;
          const draw = () => { raf = 0; if (src && box.isConnected) inkLike(cv, src, view); };
          const redraw = () => { clamp(); range.value = String(Math.round(view.z * 100)); if (!raf) raf = requestAnimationFrame(draw); };
          /* zoom about a point of the frame (0..1 across it), so what's under the fingers stays put */
          const zoomAt = (k, fx, fy) => {
            if (!src) return;
            const s0 = Math.max(LIKE_W / src.width, LIKE_H / src.height) * view.z;
            const px = view.cx + (fx - 0.5) * LIKE_W / (src.width * s0), py = view.cy + (fy - 0.5) * LIKE_H / (src.height * s0);
            view.z = Math.min(4, Math.max(1, view.z * k));
            const s1 = Math.max(LIKE_W / src.width, LIKE_H / src.height) * view.z;
            view.cx = px - (fx - 0.5) * LIKE_W / (src.width * s1); view.cy = py - (fy - 0.5) * LIKE_H / (src.height * s1);
            redraw();
          };
          const pan = (dxCss, dyCss) => {
            if (!src) return;
            const r = box.getBoundingClientRect(), s = Math.max(LIKE_W / src.width, LIKE_H / src.height) * view.z;
            view.cx -= dxCss * (LIKE_W / r.width) / (src.width * s); view.cy -= dyCss * (LIKE_H / r.height) / (src.height * s);
            redraw();
          };
          /* one finger drags, two pinch (and drag by their middle), the wheel zooms where the pointer is */
          const pts = new Map();
          let pinch = null;
          box.addEventListener('pointerdown', (e) => {
            if (!src) return;
            e.preventDefault();
            try { box.setPointerCapture(e.pointerId); } catch (x) { /* fine */ }
            pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
            if (pts.size === 2) { const [a, b] = [...pts.values()]; pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 }; }
          });
          box.addEventListener('pointermove', (e) => {
            const p = pts.get(e.pointerId); if (!p) return;
            if (pts.size === 1) { pan(e.clientX - p.x, e.clientY - p.y); p.x = e.clientX; p.y = e.clientY; return; }
            p.x = e.clientX; p.y = e.clientY;
            const [a, b] = [...pts.values()], d = Math.hypot(a.x - b.x, a.y - b.y) || 1, mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
            if (pinch) {
              const r = box.getBoundingClientRect();
              pan(mx - pinch.mx, my - pinch.my);
              zoomAt(d / pinch.d, (mx - r.left) / r.width, (my - r.top) / r.height);
            }
            pinch = { d, mx, my };
          });
          const up = (e) => { pts.delete(e.pointerId); if (pts.size < 2) pinch = null; };
          box.addEventListener('pointerup', up); box.addEventListener('pointercancel', up); box.addEventListener('lostpointercapture', up);
          box.addEventListener('wheel', (e) => {
            if (!src) return;
            e.preventDefault();
            const r = box.getBoundingClientRect();
            zoomAt(Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.0015)), (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
          }, { passive: false });
          box.addEventListener('keydown', (e) => {
            const step = 12, k = e.key;
            if (k === 'ArrowLeft') pan(step, 0); else if (k === 'ArrowRight') pan(-step, 0);
            else if (k === 'ArrowUp') pan(0, step); else if (k === 'ArrowDown') pan(0, -step);
            else if (k === '+' || k === '=') zoomAt(1.15, 0.5, 0.5); else if (k === '-' || k === '_') zoomAt(1 / 1.15, 0.5, 0.5);
            else return;
            e.preventDefault();
          });
          range.addEventListener('input', () => { if (src) zoomAt((+range.value / 100) / view.z, 0.5, 0.5); });
          zOut.addEventListener('click', () => zoomAt(1 / 1.2, 0.5, 0.5));
          zIn.addEventListener('click', () => zoomAt(1.2, 0.5, 0.5));
          use.addEventListener('click', () => {
            if (!src) return;
            if (raf) { cancelAnimationFrame(raf); raf = 0; }
            const out = inkLike(document.createElement('canvas'), src, view);
            close(out);
          });
          other.addEventListener('click', () => { close(null); pickLike(c); });
          no.addEventListener('click', () => close(null));
          /* the picture, read and shrunk on the device; a tall portrait starts on its upper third, where the face usually is */
          readPicture(file).then((cvs) => {
            if (!box.isConnected) return;
            src = cvs;
            const s = Math.max(LIKE_W / src.width, LIKE_H / src.height);
            view.cy = src.height * s > LIKE_H * 1.25 ? 0.34 : 0.5;
            wait.remove(); use.disabled = false;
            redraw();
          }, (e) => {
            wait.textContent = e && e.message === 'size' ? 'That picture is too big. Try a smaller one.' : 'That picture didn’t open. Try a JPG or PNG.';
            tip.hidden = true;
          });
        }, { title: 'Fit the likeness' });
        if (!got || !ctx.alive()) return;
        like = { name: c.name, cv: got };
        likeKeep(c.name, got);
        if (P.named) showLike(true, true);
        afterLike(c);
      }

      /* the gold counting up on the poster as Hobb writes it */
      async function countUp(from, to) {
        elReward.textContent = '';
        const amt = h('span', { class: 'bnt-amt bnt-wet', text: String(from) }), gw = h('span', { class: 'bnt-gold', text: 'gold' });
        elReward.append(amt, gw); fitText();
        if (RM()) { amt.textContent = String(to); S && S.gold({ n: 4 }); return; }
        const t0 = performance.now(), dur = 900, steps = Math.min(9, Math.ceil((to - from) / 40));
        let ticks = 0;
        await new Promise((res) => {
          const tick = () => {
            if (!ctx.alive()) return res();
            const u = Math.min(1, (performance.now() - t0) / dur), e = 1 - Math.pow(1 - u, 3), v = Math.round((from + (to - from) * e) / 10) * 10;
            amt.textContent = String(u >= 1 ? to : v);
            const want = Math.floor(e * steps);
            while (ticks < want) { ticks++; S && S.gold({ n: 1 }); }
            if (u < 1) requestAnimationFrame(tick); else res();
          };
          requestAnimationFrame(tick);
        });
        S && S.gold({ n: 3 });
        setTimeout(() => amt.classList.remove('bnt-wet'), 500);
      }
      async function strikeAndDouble(g2) {
        const amt = elReward.querySelector('.bnt-amt');
        await ctx.wait(RM() ? 0 : 420);
        amt.classList.remove('bnt-amt'); amt.classList.add('bnt-old');
        const neu = h('span', { class: 'bnt-amt bnt-ink bnt-wet', text: String(g2) });
        elReward.insertBefore(neu, elReward.querySelector('.bnt-gold'));
        fitText();
        requestAnimationFrame(() => amt.classList.add('is-struck'));
        S && S.pen();
        await ctx.wait(RM() ? 0 : 300);
        neu.style.setProperty('--bnt-ms', (RM() ? 0 : 420) + 'ms');
        requestAnimationFrame(() => neu.classList.add('is-in'));
        S && S.pen();
        await ctx.wait(RM() ? 0 : 480);
        S && S.crit(); ctx.fx.flash('rgba(244,214,138,.22)', F.el);
        const G = geoNow();
        if (G) { const r = art.getBoundingClientRect(); ctx.fx.sparks(art, { x: r.left + G.left + G.w * 0.6, y: r.top + G.top + G.h * 0.9, n: 22, spread: 90 }); }
        setTimeout(() => neu.classList.remove('bnt-wet'), 700);
      }
      async function smudge() {
        await ctx.wait(RM() ? 0 : 380);
        const G = geoNow(); if (!G) return;
        const amt = elReward.querySelector('.bnt-amt');
        amt.textContent = '900'; fitText();
        const r = Math.max(3, Math.round(G.geo.w * 0.046));
        paintBlot(blot, r);
        const px = G.w / G.geo.w, ar = amt.getBoundingClientRect(), pr = poster.getBoundingClientRect();
        const bw = blot.width * px, bh = blot.height * px;
        P.blot = { x: (ar.left - pr.left + ar.width * 0.74 - bw / 2) / G.w, y: (ar.top - pr.top + ar.height * 0.5 - bh * 0.45) / G.h, w: bw / G.w, h: bh / G.h };
        Object.assign(blot.style, { width: bw + 'px', height: bh + 'px', left: P.blot.x * 100 + '%', top: P.blot.y * 100 + '%' });
        S && S.fumble(); ctx.fx.shake(art, 5); ctx.fx.flash('rgba(40,30,70,.25)', F.el);
        FFD.buzz(50);
        requestAnimationFrame(() => blot.classList.add('is-in'));
        amt.classList.add('bnt-smudge');
        await ctx.wait(RM() ? 0 : 600);
      }

      /* ---- the card to save: the board as it stands, the poster crisp on it ---- */
      async function drawCard(g, W, H, c) {
        try { await document.fonts.load('700 60px Cinzel'); await document.fonts.load('italic 700 60px "Cormorant Garamond"'); await document.fonts.load('italic 600 60px "Cormorant Garamond"'); } catch (e) { /* fallbacks */ }
        g.fillStyle = '#0d0a07'; g.fillRect(0, 0, W, H);
        const G = geoNow(), cv = G && G.cv;
        let k = 1, ox = 0, oy = 0;
        if (cv) {
          k = Math.max(W / cv.width, (H - 120) / cv.height, W * 0.5 / G.geo.w);
          const gx = G.geo.x + G.geo.w / 2, gy = G.geo.y + G.geo.h / 2;
          ox = Math.round(Math.min(0, Math.max(W - cv.width * k, W / 2 - gx * k)));
          oy = Math.round(Math.min(0, Math.max(H - 120 - cv.height * k, (H - 120) / 2 - gy * k)));
        }
        /* the poster first, then the board over it (the window lets it through, tinted as on the page) */
        const pw = G ? G.geo.w * k : W * 0.6, ph = G ? G.geo.h * k : W * 0.6 * 1.28, px = G ? ox + G.geo.x * k : (W - pw) / 2, py = G ? oy + G.geo.y * k : 120;
        g.imageSmoothingEnabled = false;
        if (paper.width) g.drawImage(paper, px, py, pw, ph);
        drawPosterText(g, px, py, pw, ph, c);
        if (cv) { try { g.drawImage(cv, ox, oy, cv.width * k, cv.height * k); } catch (e) { /* the board stays out */ } }
        /* a dark band at the foot with the small mark */
        const grd = g.createLinearGradient(0, H - 220, 0, H); grd.addColorStop(0, 'rgba(13,10,7,0)'); grd.addColorStop(0.55, 'rgba(13,10,7,.92)'); grd.addColorStop(1, '#0d0a07');
        g.fillStyle = grd; g.fillRect(0, H - 220, W, 220);
        g.textAlign = 'center'; g.fillStyle = '#efe7d6'; g.font = 'italic 600 40px "Cormorant Garamond", Georgia, serif';
        g.fillText(fmt(likeOn ? 'Every hunter in Marrow’s End knows {Name}’s face.' : 'Nobody in Marrow’s End has seen {Name}’s face.'), W / 2, H - 82);
        g.fillStyle = '#c8a45e'; g.font = '600 24px Cinzel, Georgia, serif';
        g.fillText('FRAMEDFANTASY.COM', W / 2, H - 36);
      }
      function drawPosterText(g, x, y, w, hh, c) {
        const fs = w / 12.4, cx = x + w / 2;
        const line = (text, v, font, color, maxW, spacing) => {
          if (!text) return;
          let size = parseFloat(font.match(/([\d.]+)px/)[1]);
          const at = (sz) => font.replace(/[\d.]+px/, sz.toFixed(1) + 'px');
          g.font = at(size); g.fillStyle = color; g.textAlign = 'center'; g.textBaseline = 'top';
          while (g.measureText(text).width > maxW && size > 8) { size *= 0.94; g.font = at(size); }
          if (spacing) try { g.letterSpacing = spacing; } catch (e) { /* older canvas */ }
          g.fillText(text, cx, y + v * hh);
          try { g.letterSpacing = '0px'; } catch (e) { /* older canvas */ }
        };
        line('WANTED', 0.054, '700 ' + (1.62 * fs).toFixed(1) + 'px Cinzel, Georgia, serif', '#22120b', w * 0.9, (0.07 * 1.62 * fs).toFixed(1) + 'px');
        line(c.name, 0.216, 'italic 700 ' + (1.42 * fs).toFixed(1) + 'px "Cormorant Garamond", Georgia, serif', '#1c1830', w * 0.88);
        line(('the ' + c.clsLabel).toUpperCase(), 0.326, '600 ' + (0.48 * fs).toFixed(1) + 'px Cinzel, Georgia, serif', '#3a2a1e', w * 0.86, (0.16 * 0.48 * fs).toFixed(1) + 'px');
        if (likeOn && like) {
          /* the likeness in the frame, cropped to the frame's shape as the page's canvas is (object-fit: cover) */
          const G = geoNow(), r = likeRect(G ? G.geo.w : 62, G ? G.geo.h : 80);
          const bx = x + r.x * w, by = y + r.y * hh, bw = r.w * w, bh = r.h * hh, sc = Math.max(bw / LIKE_W, bh / LIKE_H);
          const sw = bw / sc, sh = bh / sc;
          g.save(); g.imageSmoothingEnabled = true; try { g.imageSmoothingQuality = 'high'; } catch (e) { /* fine */ }
          g.drawImage(like.cv, (LIKE_W - sw) / 2, (LIKE_H - sh) / 2, sw, sh, bx, by, bw, bh);
          g.restore();
        } else {
          g.font = 'italic 500 ' + (0.5 * fs).toFixed(1) + 'px "Cormorant Garamond", Georgia, serif'; g.fillStyle = '#6a5a48'; g.textAlign = 'center'; g.textBaseline = 'top';
          g.fillText('No likeness', cx, y + 0.444 * hh); g.fillText('on file', cx, y + 0.444 * hh + 0.6 * fs);
        }
        line((elFor.textContent || '').toUpperCase(), 0.606, '600 ' + (0.44 * fs).toFixed(1) + 'px Cinzel, Georgia, serif', '#3a2a1e', w * 0.8, (0.2 * 0.44 * fs).toFixed(1) + 'px');
        /* the charge, wrapped to the box */
        g.font = 'italic 600 ' + (0.76 * fs).toFixed(1) + 'px "Cormorant Garamond", Georgia, serif'; g.fillStyle = '#1c1830';
        const words = (P.chargePoster || '').split(' '), lines = []; let cur = '';
        words.forEach((wd) => { const t = cur ? cur + ' ' + wd : wd; if (g.measureText(t).width > w * 0.82 && cur) { lines.push(cur); cur = wd; } else cur = t; });
        if (cur) lines.push(cur);
        const lh = 0.8 * fs, top = y + 0.644 * hh + (0.146 * hh - lines.length * lh) / 2;
        lines.slice(0, 3).forEach((ln, i) => g.fillText(ln, cx, top + i * lh));
        line('REWARD', 0.824, '600 ' + (0.44 * fs).toFixed(1) + 'px Cinzel, Georgia, serif', '#3a2a1e', w * 0.8, (0.2 * 0.44 * fs).toFixed(1) + 'px');
        const gtxt = P.goldText === '9, 90 or 900' ? '900' : String(P.gold || '');
        line(gtxt + ' gold', 0.862, 'italic 700 ' + (1.18 * fs).toFixed(1) + 'px "Cormorant Garamond", Georgia, serif', '#1c1830', w * 0.6);
        if (P.blot && blot.width) {
          /* the natural 1's blot over the last two noughts, as on the board */
          let fsz = 1.18 * fs; g.font = 'italic 700 ' + fsz.toFixed(1) + 'px "Cormorant Garamond", Georgia, serif';
          while (g.measureText(gtxt + ' gold').width > w * 0.6 && fsz > 8) { fsz *= 0.94; g.font = 'italic 700 ' + fsz.toFixed(1) + 'px "Cormorant Garamond", Georgia, serif'; }
          const tw = g.measureText(gtxt + ' gold').width, nw = g.measureText(gtxt).width, bw = P.blot.w * w, bh = P.blot.h * hh;
          g.imageSmoothingEnabled = false;
          g.drawImage(blot, cx - tw / 2 + nw * 0.74 - bw / 2, y + 0.862 * hh + fsz * 0.5 - bh * 0.45, bw, bh);
        }
        g.fillStyle = 'rgba(140,26,34,.85)'; g.fillRect(cx - w * 0.17, y + 0.862 * hh + 1.12 * fs, w * 0.34, Math.max(2, fs * 0.08));
        line('BY ORDER OF THE SHERIFF OF MARROW’S END', 0.956, '600 ' + (0.3 * fs).toFixed(1) + 'px Cinzel, Georgia, serif', '#4a3a2e', w * 0.86, (0.14 * 0.3 * fs).toFixed(1) + 'px');
      }

      /* ---- under the frame: for the DM, one question, the notes ---- */
      function reference(parent) {
        parent.append(h('h2', { text: 'For the DM' }));
        ctx.prose(['Put a price on a player’s character the night before you play (choose “A player’s character”), and send them the poster. Then roll a d6 for who comes hunting.'], { parent });
        parent.append(h('div', { class: 'bnt-dm' }, h('table', null, h('tbody', null,
          [['1', 'Two farmhands with one pitchfork. They give up at the first locked door.'],
            ['2', 'A pair of sellswords. They’ll take half the reward to look the other way.'],
            ['3', 'A ranger who never blinks. She tracks the party by the mud on their boots.'],
            ['4', 'A dwarf with a crossbow and a ledger. He has caught nine and wants ten.'],
            ['5', 'Hobb’s own mother. She won’t fight anyone, but she knows everyone’s mother.'],
            ['6', 'Someone who never takes a poster down, only copies it. Nobody knows who they report to.']].map((r) => h('tr', null, h('td', { text: r[0] }), h('td', { text: r[1] })))))));
        parent.append(h('p', { class: 'ffd-tip', text: 'I’d post it a session before anyone comes looking, and let the player find it first. Change the names to fit.' }));
        ctx.faq([{ q: 'Does my character’s name go anywhere?', a: '<p>No. The name, the charge, the poster and any likeness you add stay on your phone. The likeness is never uploaded, and the picture only goes where you send it.</p>' }], { parent });
        ctx.notes([
          '<b>A likeness on the poster.</b> At the end of a round, “Add a likeness” opens your own pictures. A small sheet fits the one you pick into the poster’s frame (drag it, pinch or slide to zoom), and Hobb’s ink takes it in the poster’s sepia, on the board and on the saved poster. It stays on this device, kept with the character’s name so their next poster has it too, and “Remove it” takes it off. With a face on the poster the line over the Quest button reads “Every hunter in Marrow’s End knows Brannoc’s face now.”',
          '<b>Ready for the store.</b> On the store Gillic Grimson and Whiskers come only once their owners say yes (their ids in the page’s heroes setting). Until then the ranger who never blinks and the dwarf with the ledger from the DM’s hunters table come instead, and the stakes read “Reach 280 and the ranger who never blinks comes herself.” Here in the demo both heroes stay. The slate and the stack of posters count in each visitor’s own browser until the shared results are installed.',
          '<b>Round five, cleaner.</b> Fewer and shorter words. The opening is one line and the two choices are short (“My character” or “A player’s character”). Hobb’s note about the charge is said over him while the ink goes on, so the box goes straight to the stakes in one sentence (“Hobb starts at 80 gold and adds 10 for every point rolled. Reach 280 and Gillic Grimson comes himself.”). The natural 20 and natural 1 lines are half as long, each hunter beat is two short lines at most, and every line said over the picture is short. The slate’s sum is in the frame’s small Cinzel numbers, the own-words sheet has a quiet gold-edged button instead of a gold slab, and the ending is the Quest button with one quiet row (save the poster, post another), led in by “Nobody in Marrow’s End has seen Brannoc’s face yet.”',
          '<b>Round four, shared.</b> Every poster anyone nails up on this page stays up, so the paper round yours thickens with everyone’s earlier posters, one over the next (nine deep at most). After each nailing Hobb walks to the slate he keeps on the board and chalks the gold on every head in Marrow’s End, the total counts up and your reward lifts off it as a +300. The ending shows the gold and the posters in one line.',
          '<b>The twist.</b> Hobb reads the going rate off his slate (everyone else’s average) and tells you how your reward stands against it, “Well over the going rate of 283. I’ve underlined it twice,” or “Under the going rate. I’ll write the number bigger.” A natural 1 he chalks as 90, to be safe.',
          '<b>Hobb is lit now.</b> He faced away from you as a dark faceless shape, which read like a watcher. He now faces you, three quarters turned toward his board, with the lantern on him. He has a hat whose brim catches the light, a face with a heavy moustache, a long coat with lit lapels, folds and buttons, a gold star that glints now and then, and his hand on the hammer. He carries each poster to the board rolled up in his hand (the hammer goes to his belt), and puts the chalk to the slate himself.',
          '<b>Cleaner board.</b> The small grey scrap at the board’s lower right is gone, and the scrap of map is now Hobb’s slate, hung from a nail on a loop of string. The chalked number is real text laid behind the picture, so anyone standing in front of the slate covers it.',
          '<b>Review pass.</b> On a phone the poster fills the picture, so the hunters’ arrival lines went up in bubbles right over the name. There they now go in the box under the speaker, and a tap on a hunter still gets a bubble. Wide screens are unchanged.',
          '<b>Round three, Jan’s featured heroes.</b> The best reward (280 gold and up) now brings two of your featured Hall heroes instead of a ranger and a dwarf. Gillic Grimson, the triton bounty hunter who checks the board before the menu, and Whiskers, the tabaxi blood hunter who finds the best cookie in every town first. On a natural 20 Gillic pushes to the front of half the town. They walk in as pixel heroes, read the poster side on, turn to you when tapped (Gillic lifts his blade), and their painted portraits show in the box when they arrive. Their lines come from their Hall pages, Gillic’s catchphrase (“Which one of you is worth the most?”), his no-armor rule and the bread roll he tracked down, and Whiskers’ “Dark gods, dark days. Good cookie though,” his cookies and his mentor’s axe. (Wynter was the first pick, but a hooded figure who was watching from the dark all along sits too close to Quest One’s hooded watchers, so she sits this one out.)',
          '<b>A goal before the roll.</b> The stakes now say it plainly, “Reach 280 and Gillic Grimson takes the job himself,” so players roll for something they can picture, and “Post another” gives them a reason to try again.',
          '<b>Clearer and shorter.</b> The opening says what you do in one line (put your character on Hobb’s poster, the dice set the reward, the reward decides who comes hunting). Hobb’s lines are shorter, the stakes are one sentence, and a gold ring breathes on the poster when it’s waiting to be rolled or nailed. The line about nobody having seen your character’s face now leads straight into the Quest button, so on a short phone no bubble covers the poster any more.',
          '<b>Liberties.</b> Gillic and Whiskers as the top hunters, Gillic in the natural 20 crowd, and his raised blade when he claims the job. On a phone Whiskers stands at the poster’s edge so the picture doesn’t cut him off, and on a wide screen the smaller folk at the back of the crowd stand a little higher so they stay clear of the box.',
          '<b>Round two.</b> The whole page now plays inside the frame. The poster is still real HTML, laid inside the art under the canvas so its handwriting stays crisp, and everything in front of it (the hammer, the nails, the lantern’s light, the hunters) is pixels. Nothing scrolls away from the board.',
          '<b>Things to touch.</b> The lantern swings, flares and scatters its three moths. Hobb turns his head and has four lines, the last one cross. His hammer raps the board, which shakes the rain off the roof. The bare patch, the poster (its loose corner lifts), the missing notice (a gust lifts it and the hunters look), the tear-off tabs (they tear one at a time and flutter down, for a lost goat called Duchess), the sheriff’s notice (its seal glints), a black cat on the board’s corner (it hisses and leaps onto the roof, back nine seconds later) and every hunter (they turn and talk in character).',
          '<b>The story steps in the art.</b> Tap the old posters or Hobb to start, the poster to roll the reward, and the poster, the hammer or Hobb to nail it up. Each of those steps writes its button on the thing itself.',
          '<b>Hobb is in the picture now</b>, waiting with his hammer up, and walks over for every job. On a phone he steps out of the picture while the hunters read, because three people don’t fit a phone’s board. On a wide screen he stays by the left post.',
          '<b>Spoiler fix.</b> The Quest’s own poster with its hooded sketch is gone. In its place is a missing notice with twelve small figures in red ink, for the twelve lost on the Hollow Stump road.',
          '<b>The DM switch</b> is the first choice in the box (“It’s my character” or “I’m the DM, it’s a player’s”). It changes the name prompt, the save button and the Quest lead-in. The hunters table moved under the frame as DM reference.',
          '<b>Two compositions.</b> On a phone the board is a close-up with the poster half the picture wide. On a wide screen the whole board stands in the upper half of the plate with the street and huts round it, and the hunters stand lower, so their heads sit above the box and under the old notices.',
          '<b>Dropped.</b> The Hall strip and the FAQ line about every Hall hero starting as a name. The only call to action is the Quest button in the box at the end, with a lead-in about the Hollow Stump road.',
          '“A bigger reward brings better hunters” is still literal. Under 170 gold two farmhands come, 170 to 279 a pair of sellswords, 280 and up Gillic Grimson and Whiskers. A natural 20 doubles it and half the town turns out behind Gillic. A natural 1 blots the number and three hunters argue about it.',
          'Not built for live. Per-page tracking, the Quest preload and a real save to photos (this demo shows the card to press and hold).'
        ], { parent });
      }
    }
  });
})();
